var _defs, _rect, _ellipse, _path, _path2, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _path3, _path4, _path5, _polygon11, _polygon12, _path6, _path7, _path8, _path9, _path10, _polygon13, _polygon14, _path11, _path12, _path13, _polygon15, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _polygon16, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _polygon17, _polygon18, _path47, _path48, _path49, _path50, _path51, _polygon19, _polygon20, _circle, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _ellipse2, _ellipse3, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _polygon21, _polygon22, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _ellipse4, _path184, _path185, _path186, _path187, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _circle2, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _ellipse13, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _ellipse14, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _ellipse15, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _ellipse16, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _ellipse17, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _path300, _path301, _path302, _path303, _polygon23, _polygon24, _path304, _path305, _circle21, _circle22, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebFigureTeaser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 247.18 277.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_20",
    x1: 115.93,
    y1: 272.67,
    x2: 175.63,
    y2: 212.97,
    gradientTransform: "matrix(-1, 0, 0, 1, 293.65, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4c9ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b39fa8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_20-2",
    x1: 111.1,
    y1: 279.14,
    x2: 126.48,
    y2: 263.75,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_441",
    x1: 31.24,
    y1: 97.7,
    x2: 63.29,
    y2: 97.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#272626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#2a292b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#383739"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_441-2",
    x1: 31.24,
    y1: 92.99,
    x2: 63.29,
    y2: 92.99,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_441"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_441-3",
    x1: 31.24,
    y1: 71.3,
    x2: 63.29,
    y2: 71.3,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_441"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.21,
    width: 167.79,
    height: 25.31,
    rx: 6.79,
    fill: "#ef5182"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.72,
    cy: 61.41,
    rx: 32.46,
    ry: 25,
    fill: "#ef5182"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.86,71.24c-1.07,7.93-9.32,16.87-16.21,20.46,12.22,0,26.08-7.23,28.59-19.31",
    transform: "translate(-3.44 -2)",
    fill: "#ef5182"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78,15.73c3.6,7.92.94,21.13-3.54,28.6,11.65-7.41,20.66-22.44,16-35",
    transform: "translate(-3.44 -2)",
    fill: "#ef5182"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "34.41 206.15 102.87 166.63 102.87 92.92 34.41 132.44 34.41 206.15",
    fill: "#cac9d1"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "0 112.57 0 186.28 34.41 206.15 34.41 132.44 0 112.57",
    fill: "#9d9a9a"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "68.46 73.05 0 112.57 34.41 132.44 102.87 92.92 68.46 73.05",
    fill: "#ededed"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "37.52 134.78 79.61 110.46 100.14 122.33 37.5 158.49 37.52 134.78",
    fill: "#ededed"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "79.61 110.46 100.14 122.32 100.14 98.6 79.61 110.46",
    fill: "#7d7474"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "37.52 162.84 37.52 198.44 100.14 162.25 100.14 126.65 72.92 142.38 37.52 162.84",
    fill: "#95928d"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "37.5 166.99 72.9 146.55 100.14 162.27 37.5 198.43 37.5 166.99",
    fill: "#ededed"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "72.92 142.38 72.92 146.53 100.14 162.25 100.14 126.65 72.92 142.38",
    fill: "#7d7474"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "100.14 122.32 68.92 122.32 37.44 140 37.52 134.78 79.61 110.46 100.14 122.32",
    fill: "#c1bbb6"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "100.14 162.25 68.92 162.25 37.44 179.94 37.5 166.99 72.9 146.55 100.14 162.25",
    fill: "#c1bbb6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M175.18,205.52l44,25.7-38.11,21.51L152.72,265l-3.82-2.17a25,25,0,0,1-7,5.75c-13.77,7.95-36,8-49.7.09S78.61,248,92.38,240a41.42,41.42,0,0,1,9.39-3.87l-1.42-.81Z",
    transform: "translate(-3.44 -2)",
    opacity: 0.44,
    fill: "url(#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_20)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.33,266c5.2,3,5.17,7.88-.06,10.9s-13.69,3-18.89,0-5.17-7.88.06-10.9S179.13,263,184.33,266Z",
    transform: "translate(-3.44 -2)",
    opacity: 0.44,
    fill: "url(#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_20-2)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172.82,185.71c-21.06,29.14-50.55,44-75.15,43.53l2.49-5.71c22.3.67,46.9-13.53,69.2-39.94Z",
    transform: "translate(-3.44 -2)",
    fill: "#8a411e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.1,199.69c1.62-3.61,0-3.07,1.6-6.68-9.71-13.82-5.82-57,7.43-84.84,1.32-2.77,2.44-6,2.44-6l0-3-3.44-2c-18.87,35.65-22.37,80.44-11.38,100.75Z",
    transform: "translate(-3.44 -2)",
    fill: "#8a411e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M151.28,172.54c-13.05,10.8-19.1,18.94-40.34,25.23.63-2.6,1.75-3.22,2.38-5.81,12.21-4.74,22.9-11.19,34.91-21.06A15.59,15.59,0,0,0,151.28,172.54Z",
    transform: "translate(-3.44 -2)",
    fill: "#f4ba76"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "129.53 183.72 126.28 182.34 126.28 165.05 129.57 163.15 129.53 183.72",
    fill: "#8a411e"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "132.81 181.83 129.53 183.72 129.53 165.49 132.81 163.59 132.81 181.83",
    fill: "#502b11"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112,222.28c-1.79,1.38-1,1.86-2.75,2.71-4.34-2-3.87-2.48-3.87-2.48-1.37-18.36-3.49-57.19,41.75-69.24l5.1,2.95C106.86,169.27,107.1,208,112,222.28Z",
    transform: "translate(-3.44 -2)",
    fill: "#8a411e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M176.33,189.13c-24.1,27.42-51.26,42.71-75.2,42.24a34.4,34.4,0,0,1,2.5-5.71c22.3.67,46.9-13.53,69.19-39.95Z",
    transform: "translate(-3.44 -2)",
    fill: "#502b11"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M162.84,193.63c-10.47-17.35-4-64.83,10.9-92.47l-3.65-1.7c-16.88,30.89-22,79.92-11,100.23,0,0,1.56-1.61,4.36-5.06Z",
    transform: "translate(-3.44 -2)",
    fill: "#502b11"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M112.28,224.49c-1.06.88-3.07.5-3.07.5-1.4-18.59-3.71-58.59,44-70-.58,2.31-2.64,3.69-3.21,6C108.78,169.38,111.31,209.86,112.28,224.49Z",
    transform: "translate(-3.44 -2)",
    fill: "#502b11"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M151.57,178.28a156.74,156.74,0,0,1-40.2,23.27l1.57-6.49a146.1,146.1,0,0,0,38.34-22.52A37.35,37.35,0,0,0,151.57,178.28Z",
    transform: "translate(-3.44 -2)",
    fill: "#c27a4a"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "96.72 221.53 100.19 223.66 97.69 229.37 94.22 227.24 96.72 221.53",
    fill: "#8a411e"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "163.66 95.18 166.65 97.46 170.3 99.16 167.31 96.88 163.66 95.18",
    fill: "#f4ba76"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M152.19,173.06s-8.14,10.22-26.5,18.16c-6.26,2.71-10.76,4.82-12.18,6.41a8.38,8.38,0,0,0-1.34,2.39,4.49,4.49,0,0,0,2,5.51l37.6,21.84,42-29.62Z",
    transform: "translate(-3.44 -2)",
    fill: "#b0a782"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M157.34,222.87l-6.68,4.7-37.58-21.85a4.48,4.48,0,0,1-2-5.5,8.46,8.46,0,0,1,1.35-2.4,5.9,5.9,0,0,1,.71-.65Z",
    transform: "translate(-3.44 -2)",
    fill: "#b0a782"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M170.75,105.78l41,26.42s-16,53-13.95,61.25c1.58,6.41-4,8.28-4,8.28l-40.72-24.2S154.4,137.18,170.75,105.78Z",
    transform: "translate(-3.44 -2)",
    fill: "#b0a782"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140.61,221.72s2.33-9,4.81-10.17,8.78.31,21.51-4.28,17-6.52,18.89-11.71,4.27-22.16,4.67-24.79,9.19-15.06,9.19-15.06.81-9.22,0-12.34-5.9-7.42-5.9-7.42S199,126,199,125s.65-.59.65-.59l-18.76-12.09a103,103,0,0,0-11.39,20.2c-4.12,10.38-21.76,58.89-21.76,58.89s-16.22,9-19.27,15S129,215,129,215Z",
    transform: "translate(-3.44 -2)",
    fill: "#9f9f9f",
    style: {
      mixBlendMode: "multiply"
    }
  }), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "143.43 100.75 143.87 99.89 143.31 99.6 148.19 95.21 147.54 94.49 142.16 99.33 142.53 100.28 143.43 100.75",
    fill: "#533324"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M115.08,242a11.07,11.07,0,0,1-4.07,6c-3.53,2.88-5.54,4.61-7,7.06s-.38,6.13,1.52,7.16a3.93,3.93,0,0,0,3.75.33c.76-.27,8-6.73,8-6.73s2.06-5.7,3.74-7.17,4.51-4.4,4.51-4.4.16-6.46-3.15-7.22S115.08,242,115.08,242Z",
    transform: "translate(-3.44 -2)",
    fill: "#e53e2e"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M104.93,205.71c1,8,6.18,23.55,6.68,24.75S113.08,243,113.08,243s.37,2.45,4.06,2.38a9.78,9.78,0,0,0,3.66-.78,10.48,10.48,0,0,0,2.7-1.6c6-5.87-.55-27.79,1.94-32.9s24.55-19.11,28.9-26.6a5.31,5.31,0,0,0,.73-3.12c-.44-6.59-12.56-13.06-16.63-13.06-4.7,0-28.3,20-30.74,23.77S104,197.72,104.93,205.71Z",
    transform: "translate(-3.44 -2)",
    fill: "#364259"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M120.56,237c0,2.36.06,5.07.24,7.59a10.48,10.48,0,0,0,2.7-1.6c6-5.87-.55-27.79,1.94-32.9s24.55-19.11,28.9-26.6a5.31,5.31,0,0,0,.73-3.12,49.65,49.65,0,0,0-5.52-1.4,24.23,24.23,0,0,0-6.55,3.86c-2.61,2.36-25.33,13.8-26.78,18S120.71,230.43,120.56,237Z",
    transform: "translate(-3.44 -2)",
    fill: "#efb2a5",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M110.3,260.87s-1.68,3.53-.7,4.88,4.29,1.41,5.7,1.47,5.21,0,7-1.36,8.41-10.42,8.41-10.42,4.89-4.51,5.54-7.33-2-7.55-2-7.55-11.51,6.59-12.59,8.07S110.3,260.87,110.3,260.87Z",
    transform: "translate(-3.44 -2)",
    fill: "#e53e2e"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M120.49,221.06c2.1,10.78,1.16,25.4,1.16,27.58s6.44,1.73,9,0a7.3,7.3,0,0,0,1.76-1.7,14.27,14.27,0,0,0,2.07-3.88s3.91-14.55,4.06-20.48A27.9,27.9,0,0,0,135.91,211s19-6.59,27.22-10.06,15.27-8.83,15.92-14.48a16.37,16.37,0,0,0-.57-7.52,3.74,3.74,0,0,0-.3-.65s-24.32-13.83-28.07-7.9a10.68,10.68,0,0,0-.16,11.29s-27.43,14.55-30.26,18.89S118.39,210.27,120.49,221.06Z",
    transform: "translate(-3.44 -2)",
    fill: "#3e4a5f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M135.54,221.78c-.26,4.54-2.1,16.17-3.08,25.16a14.27,14.27,0,0,0,2.07-3.88s3.91-14.55,4.06-20.48A27.9,27.9,0,0,0,135.91,211s19-6.59,27.22-10.06,15.27-8.83,15.92-14.48a16.37,16.37,0,0,0-.57-7.52c-1.07,0-1.7,0-1.7,0a24.09,24.09,0,0,1-2.51,11.43c-3,6.17-10.27,7.68-21.57,11.59s-20.84,8.25-20.84,8.25S135.89,215.55,135.54,221.78Z",
    transform: "translate(-3.44 -2)",
    fill: "#efb2a5",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M122.8,137.45c.61.16,1.94-.27,3.49-.91,2.85-1.18,6.45-3.11,7.81-3.58,2.1-.72,8.27-3.74,8.58-4.8.15-.51,3.4-4.63,6.22-8.81,3.06-4.6,5.59-9.27,2.93-9.41-7.09-.37-20.7,11.94-24.25,13.61s-7.6,3.69-8.68,5.93S121.07,137,122.8,137.45Z",
    transform: "translate(-3.44 -2)",
    fill: "#9dcb3b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M122.15,127.89s1.15,5.22,4.14,8.65c2.85-1.18,6.45-3.11,7.81-3.58,2.1-.72,8.27-3.74,8.58-4.8.15-.51,3.4-4.63,6.22-8.81-.53-.32-1-.43-1.12-.29-.87.72-8.76,8.62-11.51,9.55a51.79,51.79,0,0,0-5.4,2.25s-2.49-2.75-5.31-3.34S122.15,127.89,122.15,127.89Z",
    transform: "translate(-3.44 -2)",
    fill: "#88b161",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M137.94,168.57c1,2,5,6.45,10.05,9.56s13.9,2.53,19.33,3.69a37.25,37.25,0,0,0,8,1c2.67-.05,4.65-.73,4.65-2.63,0-3.61-1.31-11.65-1.24-14.4s2.46-12.09,4.06-17c.36-1.12.81-2.88,1.28-5,1.59-7.1,3.44-17.92,3-19.43-.57-2-6.51-5.57-10.05-8.47s-5.07-2.46-8-4.44-17.16-1.49-17.16-1.49-1.66.94-5.14,7.82a62.88,62.88,0,0,0-4.91,14c-.52,5.43-.15,5.87-.44,8.77a42.9,42.9,0,0,0,0,5.27c.06,1.88.12,4.08.07,6.73,0,.38,0,.77,0,1.17-.22,6.3-2.25,8.55-2.25,9.12S136.92,166.62,137.94,168.57Z",
    transform: "translate(-3.44 -2)",
    fill: "#71a441"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M127.25,173.83s6.23,2.85,14.67,7,17.09,10.35,17.84,15.89,2.1,8.05,2,8.79-17.27,12.81-17.27,12.81-3.12,16.27-3.77,16.95-13.14,4.88-19-1.26-10-4.11-13.12-7.36-5.88-29-5-32.84S122,173.41,127.25,173.83Z",
    transform: "translate(-3.44 -2)",
    fill: "#d6c38c"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M133.88,237.13c-.71-4.26-1.62-10.49-1.25-12.14.59-2.55,2.9-17.28,2.9-17.28a3.25,3.25,0,0,1,2.64-4.47c4-.85,16.53-2.9,17.87-3A19.74,19.74,0,0,0,160,198a37.91,37.91,0,0,0,1.25,5.33c-6.59,2.8-11.57,7.09-14.71,9.6a51.85,51.85,0,0,0-4.16,3.48s-3.78,2-3.61,5.16c.12,2.34.62,9.82,1,14.19A26.44,26.44,0,0,1,133.88,237.13Z",
    transform: "translate(-3.44 -2)",
    fill: "#e4cac4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M120.22,232.53s-3-20.57-3-23.12-3-7.43,1.5-12.24,15.34-8.93,15.34-8.93-13,8.51-13.88,13,.93,26.39,2.51,33.58a10.17,10.17,0,0,1-.92-.82,20.91,20.91,0,0,0-1.56-1.48Z",
    transform: "translate(-3.44 -2)",
    fill: "#e4cac4"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M170.91,110.27s5.18,2.56,6.93,5.06,1.27,5.25-3.86,8.82-9.47,7.42-15.76,6.16-4.42-14.91-3.08-17.51S168.23,108.76,170.91,110.27Z",
    transform: "translate(-3.44 -2)",
    fill: "#dfe7ed"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M119.66,163.62c.64.25,12.43,6.68,14.05-2.71.83-4.85,4.23-8.42,7.3-10.74A28.77,28.77,0,0,1,146.5,147l-8.89-4.69s-12.59,5.14-15.26,11.05a44.28,44.28,0,0,0-2,5.1C119.39,161.51,119.24,163.44,119.66,163.62Z",
    transform: "translate(-3.44 -2)",
    fill: "#792a90"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M120.38,158.44c2.94-3.94,7.84-10,8.46-10,.87-.06,5.55-.91,7.88,0s4.06,1.64,4.29,1.74A28.77,28.77,0,0,1,146.5,147l-8.89-4.69s-12.59,5.14-15.26,11.05A44.28,44.28,0,0,0,120.38,158.44Z",
    transform: "translate(-3.44 -2)",
    fill: "#5d2775"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M135.53,173.9l4.68-1.29a56.88,56.88,0,0,1,6.29,5c3.12,2.89,9.62,2.93,9.62,2.93s7-.92,8-2c.8-.86.28-11.7.08-15.45,3.82,2.85,8.23,6.18,8.23,6.18l2.17,1.74s1.51,5.06,1.62,6.15c0,.45-.36,2.76-.84,5.6,2.67-.05,4.65-.73,4.65-2.63,0-3.61-1.31-11.65-1.24-14.4s2.46-12.09,4.06-17c.36-1.12.81-2.88,1.28-5-1.94-3.64-4.33-6.27-7.26-7.2a96.15,96.15,0,0,0-.68,9.77c0,4.28.68,13.69.68,13.69s-7.87-6-10.61-7.18-6.48-3.1-8.91-4-7.8-.55-7.8-.55l-8.21-2.54c.06,1.88.12,4.08.07,6.73l.9,1.39a18.56,18.56,0,0,0,2.33,1.23l-3.9,9.17Zm16.24-18.05a5.48,5.48,0,0,1,1.52.29,25.74,25.74,0,0,1,5.91,3.31Z",
    transform: "translate(-3.44 -2)",
    fill: "#88b161",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M117.52,135.63s3.69,4.28,5.8,5.08a40.79,40.79,0,0,0,6.58,1.37,6.91,6.91,0,0,1,1-1.92,10.07,10.07,0,0,1,2.07-2.21,6,6,0,0,1,5.47-.81c-.52-.33-8.82-5.6-9.74-7.07s-4.85-2.39-4.85-2.39a5.29,5.29,0,0,0-5.79,2.39,5.79,5.79,0,0,0-.86,2.83A7.79,7.79,0,0,0,117.52,135.63Z",
    transform: "translate(-3.44 -2)",
    fill: "#a8cf3b"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M176.81,140.19s1.8,9.64,2.53,11.66a45.9,45.9,0,0,1,1,4.84c.82,4.55,1.87,10.55,2.7,10.94,1.22.58,5.35,2.9,7.52-1.16s2-12.73,1.23-17.44-1.45-13-2.24-17.66-2.1-7.39-2.8-7.66a7.53,7.53,0,0,0-7.77,3.81,10.78,10.78,0,0,0-.94,2.06C176.49,134.06,176.81,140.19,176.81,140.19Z",
    transform: "translate(-3.44 -2)",
    fill: "#9dcb3b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M176.81,140.19s1.8,9.64,2.53,11.66a45.9,45.9,0,0,1,1,4.84,4.24,4.24,0,0,0,1.13.27c1.64,0,5.44,1.51,4.89-.82s-4.52-4.17-4.52-4.17-1.56-5.11-2.1-7.94-1.69-14.46-1.69-14.46a0,0,0,0,0,0,0C176.49,134.06,176.81,140.19,176.81,140.19Z",
    transform: "translate(-3.44 -2)",
    fill: "#88b161",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M171.11,102s.67,7.25.81,9.12,4.13,4.24,4.51,5.22-9.61,11.1-15.42,11.17-5-12.26-4.83-13.94.7-10.16,1.3-11.3S167.58,97.94,171.11,102Z",
    transform: "translate(-3.44 -2)",
    fill: "#fdcdad"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.07,112.18l-5.14,5.47s-1.23.69-1.23.83,1.12,1.3,1.12,2.06.22,5.5.11,5.72-1.05-3.22-1.23-3.58-.43-2.21-1.52-2.21-1.87.32-2.91.32a10.7,10.7,0,0,1-5.49-2.35c-2.09-1.62-1.15-6.85-1.15-7a2,2,0,0,1,1.72-1.75c1.43-.14,6.89,1.31,6.89,1.31Z",
    transform: "translate(-3.44 -2)",
    fill: "#ecc0af",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M153.07,91.62a7.68,7.68,0,0,0-2.92,3.71,15.81,15.81,0,0,0-.78,6.75c.29,3.41,3.59,12.82,4.89,14.08a4.67,4.67,0,0,0,4.42,1,23.63,23.63,0,0,0,4.74-2.25s3.87-2.17,4.88-4.27a18.41,18.41,0,0,0,1.63-6.84c0-1.7-3.8-10.06-5-10.42S153.07,91.62,153.07,91.62Z",
    transform: "translate(-3.44 -2)",
    fill: "#fdcdad"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M151.65,101.18a43.18,43.18,0,0,1,4.55.74c2.48.55,4.86.74,5.71,1.69a2.58,2.58,0,0,1,.08,3.15,5.23,5.23,0,0,1-3.59,1.82c-1-.08-2.49.06-2.58.3s1.55,3.42,3.48,3.12,5.16-3.28,5.78-4.67-.68-5.21-.68-5.21a18.55,18.55,0,0,0-5.21-4.18,54.13,54.13,0,0,0-7.06-2.77A7.16,7.16,0,0,0,151.65,101.18Z",
    transform: "translate(-3.44 -2)",
    fill: "#fddac2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M148.16,105.29a4.57,4.57,0,0,1-1.27-4.75,2.07,2.07,0,0,1,1.48-1.33,2.65,2.65,0,0,1,2.34.78,4.61,4.61,0,0,1,1.28,4.76h0a2.11,2.11,0,0,1-1.48,1.33,2.2,2.2,0,0,1-.44,0A2.84,2.84,0,0,1,148.16,105.29Zm.43-5.07a1.06,1.06,0,0,0-.75.71,3.62,3.62,0,0,0,1,3.61,1.61,1.61,0,0,0,1.42.53,1.06,1.06,0,0,0,.75-.71h0a3.6,3.6,0,0,0-1-3.61,1.86,1.86,0,0,0-1.2-.56A.83.83,0,0,0,148.59,100.22Z",
    transform: "translate(-3.44 -2)",
    fill: "#533324"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M153,94.67a27.06,27.06,0,0,1,6.2,2.38,29.47,29.47,0,0,1,6,4.75,30,30,0,0,1,1.08,2.85c.37.84,1.17,2.54,1.28,2.94s.61,1.77.61,1.77-.58-4.09-.61-4.34.43-.8.43-.8a10.61,10.61,0,0,1,1.38,1.27c.39.49.25,0,.61.32a39.11,39.11,0,0,1,1.92,4.46s.51-3,1.59-3.37a5.28,5.28,0,0,0,2.83-2.45,6.42,6.42,0,0,0,.39-4.44A13.39,13.39,0,0,0,175.11,97a16.26,16.26,0,0,0-1.78-7.1c-1.84-3.51-6.73-5.72-8.68-6A8.67,8.67,0,0,0,156.79,85a16.33,16.33,0,0,0-5.5,5.17,5.61,5.61,0,0,0-1,4.74l1.75-.68Z",
    transform: "translate(-3.44 -2)",
    fill: "#929090"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M150.27,95a3.93,3.93,0,0,1-.15-1.16l2.64-.43.36.24a8.43,8.43,0,0,1,2.9,0,38.83,38.83,0,0,1,8.07,3.19c.37.35,2,2.34,2,2.34a11.38,11.38,0,0,0,2.21.51,5.19,5.19,0,0,0,2.26-.22l3.5-3a4.25,4.25,0,0,1,1-.49c.05.6.05,1,.05,1s.43.65.85,1.42l-.39-.1-3.75,1.93,2.5,1.72s.32.83,1,.5.61-2.74.61-2.74v-.51a.91.91,0,0,1,.26-.35,5.32,5.32,0,0,1,.47,1.19,6.42,6.42,0,0,1-.39,4.44,5.28,5.28,0,0,1-2.83,2.45c-1.08.36-1.59,3.37-1.59,3.37a39.11,39.11,0,0,0-1.92-4.46c-.36-.32-.22.17-.61-.32a10.61,10.61,0,0,0-1.38-1.27s-.47.54-.43.8.61,4.34.61,4.34-.51-1.38-.61-1.77-.91-2.1-1.28-2.94a30,30,0,0,0-1.08-2.85,29.47,29.47,0,0,0-6-4.75,27.06,27.06,0,0,0-6.2-2.38l-.93-.4Z",
    transform: "translate(-3.44 -2)",
    fill: "#6d6c6c"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M155.7,108.92a4.61,4.61,0,0,1-1.28-4.76,2.11,2.11,0,0,1,1.48-1.33,2.67,2.67,0,0,1,2.35.79,4.59,4.59,0,0,1,1.27,4.76h0A2.08,2.08,0,0,1,158,109.7a1.61,1.61,0,0,1-.44,0A2.87,2.87,0,0,1,155.7,108.92Zm.42-5.08a1.07,1.07,0,0,0-.74.71,3.62,3.62,0,0,0,1,3.61,1.63,1.63,0,0,0,1.42.54,1.09,1.09,0,0,0,.75-.72h0a3.59,3.59,0,0,0-1-3.6,1.85,1.85,0,0,0-1.2-.57A.91.91,0,0,0,156.12,103.84Z",
    transform: "translate(-3.44 -2)",
    fill: "#533324"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "157.03 105.56 157.2 105.49 167.3 101.43 166.95 100.53 157.01 104.53 155.54 104.01 155.22 104.92 157.03 105.56",
    fill: "#533324"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M154.52,104l.8-.54c-.06-.09-1.56-2.27-3.93-1.91l.14,1A3.5,3.5,0,0,1,154.52,104Z",
    transform: "translate(-3.44 -2)",
    fill: "#533324"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M169,106.74c0,.18,0,1.15.78,1.19s2.3-1.65,2.73-2.59a3,3,0,0,0,.1-3c-.62-1-2.63.14-2.63.14s-.86,1.64-1,2.06A14.11,14.11,0,0,0,169,106.74Z",
    transform: "translate(-3.44 -2)",
    fill: "#fddac2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M152.24,105.16s-1.45,4.36-.75,4.92,2.76.74,2.73-.15a6.48,6.48,0,0,0-1-2.38S152.7,102.94,152.24,105.16Z",
    transform: "translate(-3.44 -2)",
    fill: "#fddac2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.52,135.63s3.69,4.28,5.8,5.08a40.79,40.79,0,0,0,6.58,1.37,6.91,6.91,0,0,1,1-1.92c-3.67-1.16-8.36-2.69-9.33-3.59-1.44-1.34-4.19-3.53-4.37-3.67A7.79,7.79,0,0,0,117.52,135.63Z",
    transform: "translate(-3.44 -2)",
    fill: "#88b161",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M129.94,142a30.38,30.38,0,0,0,1.72,3.48.53.53,0,0,0,.13.13,4.52,4.52,0,0,0,1.34.53s.27.32.44.24a9.58,9.58,0,0,1,1.52,0,6.61,6.61,0,0,0,2.06.79c.65,0,1.29.05,1.29.05s1.75.6,2.18.22a.91.91,0,0,0,.12-.69h0c-.05-.91-.47-2.39-.47-2.67s1.19-3.88,1.19-3.88v-1.87a14.79,14.79,0,0,0-2.12-.81c-.07.05-2.46-.41-2.46-.41l-1.36.68a17.71,17.71,0,0,0-1.93,0c-1,0-1.06.55-1.06.55a13.47,13.47,0,0,0-1.71.45,3.65,3.65,0,0,0-.78,1A13.91,13.91,0,0,0,129.94,142Z",
    transform: "translate(-3.44 -2)",
    fill: "#fdcdad"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M131.79,145.57a4.52,4.52,0,0,0,1.34.53s.27.32.44.24a9.58,9.58,0,0,1,1.52,0,6.61,6.61,0,0,0,2.06.79c.65,0,1.29.05,1.29.05s1.75.6,2.18.22a.91.91,0,0,0,.12-.69h0a4.21,4.21,0,0,0-.77-.25l-1.74-.41L137.5,145l-.16-1.11.33-3.88-.82,3.37.27,2.26-1.76-.53-.22-5.57-.68,2.77.3,3.12-.95-.07-.84-1.81-.76-3.38.22,3.38.7,1.81-.76.1Z",
    transform: "translate(-3.44 -2)",
    fill: "#ecc0af",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M146.15,161c.48,2.34-1.85,16-1.85,16a15.38,15.38,0,0,0,6.7,2.19,40.06,40.06,0,0,0,7.52-.83l1.54-.31s.49-9,.49-15.46-7.08-13.33-7.08-13.33H142.6l.58,1.82C144.1,154,145.8,159.33,146.15,161Z",
    transform: "translate(-3.44 -2)",
    fill: "#79459b"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M153.47,149.3H142.6l.58,1.82.27.11,2.35,4.23s5.28-2.56,7.33-2.6,4.83,4.19,5.12,6.82.44,17.75.44,17.75l-.17,1,1.54-.31s.49-9,.49-15.46S153.47,149.3,153.47,149.3Z",
    transform: "translate(-3.44 -2)",
    fill: "#5d2775"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M139.53,147.28l2.36-1.45,15.57-10.29s1,.47.7,1.14-16.22,9.89-16.22,9.89l-3.63,2.15Z",
    transform: "translate(-3.44 -2)",
    fill: "#dfe7ed"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M140.21,146.45s.25.32.5.58.31.34.37.34h1.69l-.61,1.83-.24.7.44.79,1.08.54a2.29,2.29,0,0,0,.91.65.91.91,0,0,0,.67,0s.81.92,1.44.92,2,.06,2.33,0,1.91-1,1.93-1.38,0-.75,0-.84a4.44,4.44,0,0,1,1.44.09,10.84,10.84,0,0,0,2.93-.09,15.57,15.57,0,0,1,3.36.43s.39-.19.89-.48c.94-.53,2.28-1.37,2.43-1.88.25-.78-2-3.79-2-3.79s-5.29-1.55-8.39-2.2a15.38,15.38,0,0,0-5.21-.39,3.66,3.66,0,0,0-1.9,1.07l-1.47.38s-1.28.83-1.65,1.16A6.74,6.74,0,0,0,140.21,146.45Z",
    transform: "translate(-3.44 -2)",
    fill: "#fdcdad"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.08,150.3l-.92-1.1-.24.7.44.79,1.08.54a2.29,2.29,0,0,0,.91.65.91.91,0,0,0,.67,0s.81.92,1.44.92,2,.06,2.33,0,1.91-1,1.93-1.38,0-.75,0-.84a4.44,4.44,0,0,1,1.44.09,10.84,10.84,0,0,0,2.93-.09,15.57,15.57,0,0,1,3.36.43s.39-.19.89-.48l-2.17-1.05-4.21-.22h-2.65l-1.62,1-.36,1.3s.75-.18.75,0-1.59.87-1.59.87l-1.41-.18v-1.41l1.74-2.57-1.74,1.3-1.26,1.81-.73-.51.21-1.48,2.25-3.81-2.64,3.43Z",
    transform: "translate(-3.44 -2)",
    fill: "#ecc0af",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.71,147c.16.18.31.34.37.34h1.69l-.61,1.83,1-1.48,2.42-3.4-2.27,1.82-1.35.68Z",
    transform: "translate(-3.44 -2)",
    fill: "#ecc0af",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M157,150.3l-.31,1.19s2.54,2,5.14,3.91,10.65,9.19,15,10.71a95.15,95.15,0,0,0,9.44,2.65,3.32,3.32,0,0,0,2.22-1.4,7.56,7.56,0,0,0,1.33-4.07c.43-5.29-1.45-6.37-3.84-8.76s-6.45-2.18-6.45-2.18l-6.15-1.58S167,147.36,163,145.62a28.88,28.88,0,0,0-6.3-2.09,4.46,4.46,0,0,1,1,2.67A24.21,24.21,0,0,1,157,150.3Z",
    transform: "translate(-3.44 -2)",
    fill: "#a8cf3b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M157,150.3l-.31,1.19s2.54,2,5.14,3.91,10.65,9.19,15,10.71a95.15,95.15,0,0,0,9.44,2.65,3.32,3.32,0,0,0,2.22-1.4,12.56,12.56,0,0,1-3.38-.09,77.24,77.24,0,0,1-12.23-5.58,142.21,142.21,0,0,1-12.53-9.26A10,10,0,0,0,157,150.3Z",
    transform: "translate(-3.44 -2)",
    fill: "#88b161",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M217.49,211.54c-21.06,29.14-50.55,44-75.15,43.53l2.49-5.71c22.3.67,46.9-13.54,69.2-40Z",
    transform: "translate(-3.44 -2)",
    fill: "#8a411e"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M203.77,225.52c1.62-3.61,0-3.08,1.6-6.68-9.71-13.83-6.65-53.9,6.59-81.78,1.32-2.78,2.44-6,2.44-6l0-3-3.44-2c-18.87,35.64-21.53,77.38-10.54,97.68Z",
    transform: "translate(-3.44 -2)",
    fill: "#8a411e"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M196,198.37c-13,10.8-19.1,18.94-40.34,25.22.63-2.59,1.75-3.21,2.38-5.81,12.21-4.74,22.9-11.19,34.91-21.05A16.25,16.25,0,0,0,196,198.37Z",
    transform: "translate(-3.44 -2)",
    fill: "#8a411e"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "174.19 209.55 170.95 208.16 170.95 190.88 174.24 188.98 174.19 209.55",
    fill: "#8a411e"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "177.48 207.65 174.19 209.55 174.19 191.31 177.48 189.41 177.48 207.65",
    fill: "#502b11"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M156.63,248.11c-1.8,1.38-1,1.85-2.75,2.71-4.34-2-3.87-2.48-3.87-2.48-1.38-18.37-3.49-57.19,41.75-69.25l5.1,2.95C151.53,195.1,151.77,233.87,156.63,248.11Z",
    transform: "translate(-3.44 -2)",
    fill: "#8a411e"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M221,215c-24.1,27.41-51.26,42.71-75.2,42.24a34.4,34.4,0,0,1,2.5-5.71c22.3.66,46.9-13.54,69.19-40Z",
    transform: "translate(-3.44 -2)",
    fill: "#502b11"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M207.51,219.46C197,202.11,202.68,157.68,217.57,130l-3.65-1.69c-16.88,30.89-21.13,76.86-10.15,97.17,0,0,1.56-1.62,4.36-5.06Z",
    transform: "translate(-3.44 -2)",
    fill: "#502b11"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M157,250.32c-1.06.88-3.07.5-3.07.5-1.4-18.6-3.71-58.6,44-70-.58,2.31-2.64,3.69-3.21,6C153.45,195.21,156,235.68,157,250.32Z",
    transform: "translate(-3.44 -2)",
    fill: "#502b11"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M196.24,204.1A156.16,156.16,0,0,1,156,227.37c.63-2.59.94-3.89,1.57-6.48A146.38,146.38,0,0,0,196,198.37,37.29,37.29,0,0,0,196.24,204.1Z",
    transform: "translate(-3.44 -2)",
    fill: "#502b11"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "141.39 247.36 144.86 249.49 142.36 255.19 138.9 253.07 141.39 247.36",
    fill: "#8a411e"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "207.49 124.07 210.48 126.35 214.13 128.04 211.14 125.76 207.49 124.07",
    fill: "#f4ba76"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 172.44,
    cy: 265.55,
    r: 11.48,
    transform: "translate(-31.03 18.11) rotate(-6.18)",
    fill: "#9654a1"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M163.6,258.21a11.47,11.47,0,0,1,8.42-4.13c.58.18,4.8,1.73,7.72,9.53a23.31,23.31,0,0,1,1.35,9.47,11.43,11.43,0,0,1-8.65,3.95,11.56,11.56,0,0,1-2.51-.28c.39-4.09.45-10-1.9-13.14A66.12,66.12,0,0,0,163.6,258.21Z",
    transform: "translate(-3.44 -2)",
    fill: "#79459b"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M163.83,273.14a11.48,11.48,0,0,1-2.88-7.59,11.24,11.24,0,0,1,.33-2.68c.85.39,3.56,1.24,8.59-.47,4.41-1.51,8.79-3,11.06-4.57a11.43,11.43,0,0,1,2.13,12.06,14.36,14.36,0,0,1-4.4,2C175.09,272.77,168.85,274.38,163.83,273.14Z",
    transform: "translate(-3.44 -2)",
    fill: "#6e3092"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M167.82,261.44a21.77,21.77,0,0,0,2.55-.14l-.28-1.91c-.13,0-12.05,1.62-15.73-7.07-4.11-9.73-11-59-7.61-76.35l-1.9-.36c-3.4,17.58,3.56,67.59,7.73,77.46C155.7,260.44,163.7,261.44,167.82,261.44Z",
    transform: "translate(-3.44 -2)",
    fill: "#79459b"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M132.62,127l9.13,17.51-1.17,1.1-9.52-17.53s-.71-1.51.15-2S132.62,127,132.62,127Z",
    transform: "translate(-3.44 -2)",
    fill: "#dfe7ed"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M153.36,143.14c.2-.55,3,0,3.32.39,1.43,1,1.93,5.91,0,8-.48.32-3-.08-3.32-.74C154.48,149.2,155.34,143.6,153.36,143.14Z",
    transform: "translate(-3.44 -2)",
    fill: "#5c5c5c"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M153.91,142.91c-.29,0-.5.09-.55.23,2,.46,1.12,6.06,0,7.61a.94.94,0,0,0,.43.36C154.93,149.39,155.78,143.68,153.91,142.91Z",
    transform: "translate(-3.44 -2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M156.23,145.15a1.58,1.58,0,0,1,1.59,1.45,1.45,1.45,0,0,1-1.1,1.77,1.6,1.6,0,0,1-1.6-1.46,1.45,1.45,0,0,1,1.11-1.76",
    transform: "translate(-3.44 -2)",
    fill: "#fff",
    stroke: "#414042",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M44.52,121.81l1-16L37.26,105h0a16.58,16.58,0,0,0-8.2,1.07c-5.92,2.21-9.71,6.72-8.47,10.07.62,1.68,2.39,2.74,4.74,3.11h0Z",
    transform: "translate(-3.44 -2)",
    fill: "#d8dad8",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M63.29,73.52l-32-.14v39.39h0c0,2.36,1.6,4.72,4.73,6.52,6.28,3.63,16.43,3.65,22.67,0,3.13-1.8,4.68-4.18,4.65-6.56h0Z",
    transform: "translate(-3.44 -2)",
    fill: "url(#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_441)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M63.29,101.31l-32-.14v7.72h0c0,2.36,1.6,4.72,4.73,6.53,6.28,3.62,16.43,3.64,22.67,0,3.13-1.81,4.68-4.19,4.65-6.57h0Z",
    transform: "translate(-3.44 -2)",
    fill: "#3c3c3d"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M63.29,101l-32-.13v7.72h0c0,2.36,1.6,4.72,4.73,6.52,6.28,3.63,16.43,3.64,22.67,0,3.13-1.81,4.68-4.18,4.65-6.56h0Z",
    transform: "translate(-3.44 -2)",
    fill: "#151517"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M63.29,68.81l-32-.14v39.39h0c0,2.36,1.6,4.72,4.73,6.52,6.28,3.63,16.43,3.64,22.67,0,3.13-1.81,4.68-4.18,4.65-6.56h0Z",
    transform: "translate(-3.44 -2)",
    fill: "url(#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_441-2)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M63.29,63.84l-32-.14v7.72h0c0,2.36,1.6,4.72,4.73,6.52,6.28,3.63,16.43,3.65,22.67,0,3.13-1.8,4.68-4.18,4.65-6.56h0Z",
    transform: "translate(-3.44 -2)",
    fill: "#3c3c3d"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M63.29,63.52l-32-.13v7.72h0c0,2.36,1.6,4.72,4.73,6.52,6.28,3.63,16.43,3.65,22.67,0,3.13-1.81,4.68-4.18,4.65-6.56h0Z",
    transform: "translate(-3.44 -2)",
    fill: "#151517"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M63.29,63l-32-.14v7.72h0c0,2.36,1.6,4.72,4.73,6.53,6.28,3.62,16.43,3.64,22.67,0,3.13-1.81,4.68-4.19,4.65-6.57h0Z",
    transform: "translate(-3.44 -2)",
    fill: "url(#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_441-3)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.27,
    cy: 62.93,
    rx: 9.25,
    ry: 16.03,
    transform: "translate(-19.36 107.85) rotate(-89.69)",
    fill: "#515153"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.27,
    cy: 62.93,
    rx: 8.98,
    ry: 15.56,
    transform: "translate(-19.36 107.85) rotate(-89.69)",
    fill: "#5fc9dd"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M57.42,68.79c-5.57,3.22-14.64,3.2-20.25,0s-5.64-8.48-.06-11.7,14.64-3.2,20.25,0S63,65.57,57.42,68.79Z",
    transform: "translate(-3.44 -2)",
    fill: "#242426"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M56.62,67.8c-5.13,3-13.48,3-18.64,0S32.79,60,37.92,57s13.47-2.95,18.64,0S61.75,64.84,56.62,67.8Z",
    transform: "translate(-3.44 -2)",
    fill: "#7b7b7c"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2,67.56c-5,2.91-13.19,2.89-18.25,0S32.87,59.89,37.89,57s13.2-2.88,18.26,0S61.23,64.66,56.2,67.56Z",
    transform: "translate(-3.44 -2)",
    fill: "#515153"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M38.67,67.53c-1.16-.66-1.17-1.73,0-2.38a4.59,4.59,0,0,1,4.16,0,1.26,1.26,0,0,1,0,2.4A4.55,4.55,0,0,1,38.67,67.53Z",
    transform: "translate(-3.44 -2)",
    fill: "#2f2e30"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M42.31,65.62a3.69,3.69,0,0,0-3.33,0,1,1,0,0,0,0,1.91,3.63,3.63,0,0,0,3.32,0C43.25,67,43.24,66.15,42.31,65.62Z",
    transform: "translate(-3.44 -2)",
    fill: "#585859"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M41.41,66.18A2.54,2.54,0,0,0,41,66a3.06,3.06,0,0,0-.88-.18,3.73,3.73,0,0,0-.47,0,.24.24,0,0,1-.18,0s0-.07,0-.11a.16.16,0,0,1,.13-.05,3,3,0,0,1,.52,0,4.17,4.17,0,0,1,.63.08l.48.14a3,3,0,0,1,.36.17,2.49,2.49,0,0,1,.32.2,1.46,1.46,0,0,1,.3.31.89.89,0,0,1,.19.39.86.86,0,0,1,0,.32c0,.06-.09.1-.2.09s-.17,0-.16-.11A.65.65,0,0,0,42,67a.77.77,0,0,0-.14-.34,1.3,1.3,0,0,0-.19-.22A2.32,2.32,0,0,0,41.41,66.18Z",
    transform: "translate(-3.44 -2)",
    fill: "#dcdadb"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M41.16,66.34a1.09,1.09,0,0,1,.47.51.64.64,0,0,1,0,.33c0,.06-.09.1-.19.1s-.18,0-.18-.11,0-.08,0-.11a.66.66,0,0,0-.2-.4,1.2,1.2,0,0,0-.38-.25,2.2,2.2,0,0,0-.83-.18h-.2a.29.29,0,0,1-.17,0,.07.07,0,0,1,0-.11.2.2,0,0,1,.14,0,2.65,2.65,0,0,1,.8.06,2.13,2.13,0,0,1,.43.13Z",
    transform: "translate(-3.44 -2)",
    fill: "#dcdadb"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M40.65,66.65a.52.52,0,0,1,.3.47.09.09,0,0,1,0,.07.25.25,0,0,1-.24,0c-.07,0-.1-.06-.09-.1a.31.31,0,0,0-.12-.27.88.88,0,0,0-.53-.19h-.16a.22.22,0,0,1-.18-.07s0-.1.07-.12l.09,0a1.85,1.85,0,0,1,.58.06A2.08,2.08,0,0,1,40.65,66.65Z",
    transform: "translate(-3.44 -2)",
    fill: "#dcdadb"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M39.59,67.23c-.15-.08-.15-.21,0-.29a.56.56,0,0,1,.52,0c.15.09.15.22,0,.3A.52.52,0,0,1,39.59,67.23Z",
    transform: "translate(-3.44 -2)",
    fill: "#dcdadb"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M55.69,58.31a1.48,1.48,0,0,1-1.33,0,.41.41,0,0,1,0-.77,1.48,1.48,0,0,1,1.33,0A.41.41,0,0,1,55.69,58.31Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M49.73,62.71c-.51,0-1-.14-1.1-.44s.23-.58.74-.63,1,.14,1.11.43S50.24,62.65,49.73,62.71Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M48.49,61.14c-.09.3-.57.5-1.08.45s-.87-.33-.78-.63.56-.49,1.07-.45S48.57,60.84,48.49,61.14Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M45.52,61.27c.45.15.61.48.36.74a1.39,1.39,0,0,1-1.28.21c-.45-.15-.62-.48-.37-.74A1.35,1.35,0,0,1,45.52,61.27Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M44.92,63.16a1.45,1.45,0,0,1,1.32-.07c.4.19.47.53.14.76a1.44,1.44,0,0,1-1.33.08C44.65,63.74,44.59,63.4,44.92,63.16Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M47.61,63.91c-.27-.26-.12-.59.32-.74a1.38,1.38,0,0,1,1.3.19c.26.26.12.59-.33.74A1.39,1.39,0,0,1,47.61,63.91Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M52.53,62.89c-.52,0-1-.23-1-.53s.4-.55.92-.56,1,.23,1,.54S53.05,62.88,52.53,62.89Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M51.42,64.34c-.46-.14-.63-.48-.38-.74a1.35,1.35,0,0,1,1.28-.21c.45.14.62.47.37.74A1.33,1.33,0,0,1,51.42,64.34Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2,65.27c-.27-.25-.13-.59.31-.74a1.36,1.36,0,0,1,1.29.18c.28.26.14.59-.31.75A1.39,1.39,0,0,1,49.2,65.27Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M46.46,65.44c0-.3.4-.55.92-.56s.95.24,1,.54S48,66,47.43,66,46.47,65.74,46.46,65.44Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M43.94,64.79a1.38,1.38,0,0,1,1.28-.22c.45.15.62.48.37.74a1.34,1.34,0,0,1-1.27.22C43.86,65.38,43.69,65.05,43.94,64.79Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M42.31,63.5a1.42,1.42,0,0,1,1.29.18c.28.26.14.6-.31.75A1.39,1.39,0,0,1,42,64.25C41.73,64,41.87,63.66,42.31,63.5Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M42,61.92c.52,0,1,.23,1,.53s-.39.55-.91.56-1-.24-1-.54S41.49,61.92,42,61.92Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M43.12,60.47c.45.14.62.47.37.74a1.36,1.36,0,0,1-1.27.21c-.46-.15-.63-.48-.38-.74A1.35,1.35,0,0,1,43.12,60.47Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M45.34,59.53c.27.26.13.6-.31.75a1.41,1.41,0,0,1-1.3-.18c-.27-.26-.13-.59.31-.75A1.41,1.41,0,0,1,45.34,59.53Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M48.07,59.37c0,.3-.39.55-.91.55s-.95-.23-1-.53.4-.55.92-.55S48.06,59.07,48.07,59.37Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M54.88,64.16c-.51-.08-.81-.38-.67-.67a1.12,1.12,0,0,1,1.15-.38c.5.08.8.37.67.66A1.12,1.12,0,0,1,54.88,64.16Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4,65.55c-.43-.17-.54-.51-.24-.76a1.45,1.45,0,0,1,1.31-.13c.43.17.53.51.24.76A1.45,1.45,0,0,1,53.4,65.55Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M51.18,66.56c-.3-.24-.2-.58.22-.75a1.47,1.47,0,0,1,1.32.13c.3.25.19.59-.23.76A1.42,1.42,0,0,1,51.18,66.56Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M48.48,67.08c-.13-.29.17-.59.67-.67a1.12,1.12,0,0,1,1.15.39c.14.29-.16.59-.66.66A1.14,1.14,0,0,1,48.48,67.08Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M45.65,67c0-.29.5-.52,1-.49s.91.29.86.59-.5.52-1,.5S45.6,67.32,45.65,67Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M39.09,62.26c.52,0,1,.19,1,.49s-.34.56-.86.59-1-.2-1-.5S38.58,62.28,39.09,62.26Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M39.66,60.65c.5.08.8.38.67.67a1.12,1.12,0,0,1-1.15.38c-.51-.08-.81-.38-.67-.67A1.11,1.11,0,0,1,39.66,60.65Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M41.14,59.26c.42.17.53.51.23.76a1.44,1.44,0,0,1-1.31.13c-.42-.18-.53-.52-.23-.76A1.42,1.42,0,0,1,41.14,59.26Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M43.36,58.24c.3.25.2.59-.23.76a1.45,1.45,0,0,1-1.31-.13c-.3-.25-.2-.59.23-.76A1.45,1.45,0,0,1,43.36,58.24Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M46.05,57.73c.14.29-.16.59-.66.67A1.16,1.16,0,0,1,44.23,58c-.13-.29.16-.59.66-.66A1.13,1.13,0,0,1,46.05,57.73Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M57.25,59.72A1.36,1.36,0,0,1,56,59.51c-.26-.26-.11-.59.34-.74a1.39,1.39,0,0,1,1.29.2C57.86,59.23,57.7,59.57,57.25,59.72Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M58.14,61.3A1.13,1.13,0,0,1,57,60.92c-.14-.29.16-.59.66-.67a1.16,1.16,0,0,1,1.16.39C58.93,60.93,58.64,61.23,58.14,61.3Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M58.28,63c-.52,0-1-.25-1-.55s.42-.54.94-.54.94.25.94.55S58.8,63,58.28,63Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M57.67,64.59c-.51-.08-.81-.37-.67-.66a1.11,1.11,0,0,1,1.15-.39c.5.08.8.38.67.67A1.12,1.12,0,0,1,57.67,64.59Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M56.35,66.07c-.45-.15-.61-.49-.35-.74a1.36,1.36,0,0,1,1.28-.2c.46.15.61.48.35.74A1.36,1.36,0,0,1,56.35,66.07Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M54.41,67.29c-.37-.21-.37-.55,0-.76a1.42,1.42,0,0,1,1.33,0,.41.41,0,0,1,0,.77A1.45,1.45,0,0,1,54.41,67.29Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M52,68.19c-.27-.26-.11-.6.34-.74a1.36,1.36,0,0,1,1.28.2c.27.26.11.59-.34.74A1.36,1.36,0,0,1,52,68.19Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M49.24,68.69c-.14-.29.16-.59.66-.67a1.14,1.14,0,0,1,1.16.39c.13.29-.16.59-.66.66A1.13,1.13,0,0,1,49.24,68.69Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M46.36,68.76c0-.3.42-.55.94-.55s.94.25.94.55-.42.54-.94.54S46.36,69.06,46.36,68.76Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M43.54,68.39A1.12,1.12,0,0,1,44.69,68c.51.08.81.38.67.67a1.12,1.12,0,0,1-1.15.38C43.71,69,43.41,68.68,43.54,68.39Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4,63.5a1.14,1.14,0,0,1,1.15.39c.14.29-.16.59-.66.66a1.12,1.12,0,0,1-1.15-.38C35.6,63.88,35.9,63.58,36.4,63.5Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M36.26,61.84c.52,0,.94.25.94.55s-.42.54-.94.54-.94-.25-.94-.55S35.74,61.84,36.26,61.84Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M36.87,60.22c.5.07.8.37.67.66a1.12,1.12,0,0,1-1.15.38c-.51-.07-.81-.37-.67-.66A1.12,1.12,0,0,1,36.87,60.22Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M38.19,58.74c.45.15.6.48.35.74a1.38,1.38,0,0,1-1.29.2c-.45-.15-.61-.48-.35-.74A1.38,1.38,0,0,1,38.19,58.74Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M40.12,57.51c.37.22.38.56,0,.77a1.48,1.48,0,0,1-1.33,0,.41.41,0,0,1,0-.77A1.48,1.48,0,0,1,40.12,57.51Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M42.55,56.62c.26.26.11.59-.34.74a1.38,1.38,0,0,1-1.29-.2c-.26-.26-.11-.59.34-.74A1.38,1.38,0,0,1,42.55,56.62Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M45.29,56.12c.14.29-.16.59-.66.67a1.14,1.14,0,0,1-1.15-.39c-.14-.29.16-.59.66-.66A1.12,1.12,0,0,1,45.29,56.12Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M48.17,56.05c0,.3-.41.54-.93.54s-1-.24-1-.54.42-.54.94-.54S48.17,55.75,48.17,56.05Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M51,56.41a1.14,1.14,0,0,1-1.15.39c-.5-.08-.8-.38-.67-.67a1.12,1.12,0,0,1,1.15-.38C50.83,55.83,51.13,56.12,51,56.41Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M53.56,57.18a1.38,1.38,0,0,1-1.29.2c-.45-.15-.61-.48-.35-.74a1.38,1.38,0,0,1,1.29-.2C53.66,56.59,53.82,56.92,53.56,57.18Z",
    transform: "translate(-3.44 -2)",
    fill: "#181011"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M53.44,61.85l-5.17-3c-.65-.38-.57-1,.18-1.46h0A2.8,2.8,0,0,1,51,57.3l5.17,3c.65.37.57,1-.18,1.46h0A2.8,2.8,0,0,1,53.44,61.85Z",
    transform: "translate(-3.44 -2)",
    fill: "#2f2e30"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M53.59,61.8l-5.23-3c-.59-.34-.52-.94.17-1.33h0a2.54,2.54,0,0,1,2.3-.1l5.23,3c.6.35.52.94-.16,1.34h0A2.59,2.59,0,0,1,53.59,61.8Z",
    transform: "translate(-3.44 -2)",
    fill: "#434345"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M51.11,58.94a2.3,2.3,0,0,1-2.09,0c-.59-.33-.59-.87,0-1.21a2.32,2.32,0,0,1,2.1,0C51.69,58.06,51.69,58.6,51.11,58.94Z",
    transform: "translate(-3.44 -2)",
    fill: "#2f2e30"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M55.48,61.46a2.33,2.33,0,0,1-2.09,0c-.59-.34-.59-.88,0-1.22a2.32,2.32,0,0,1,2.1,0A.64.64,0,0,1,55.48,61.46Z",
    transform: "translate(-3.44 -2)",
    fill: "#2f2e30"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M55.36,61.47a2,2,0,0,1-1.85,0,.56.56,0,0,1,0-1.07,2.07,2.07,0,0,1,1.86,0A.57.57,0,0,1,55.36,61.47Z",
    transform: "translate(-3.44 -2)",
    fill: "#49494a"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M51,58.94a2,2,0,0,1-1.85,0c-.52-.3-.52-.78,0-1.07a2.07,2.07,0,0,1,1.86,0A.57.57,0,0,1,51,58.94Z",
    transform: "translate(-3.44 -2)",
    fill: "#49494a"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M50.87,58.81a1.78,1.78,0,0,1-1.62,0,.5.5,0,0,1,0-.94,1.78,1.78,0,0,1,1.62,0C51.32,58.14,51.32,58.55,50.87,58.81Z",
    transform: "translate(-3.44 -2)",
    fill: "#585859"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M55.25,61.34a1.78,1.78,0,0,1-1.62,0,.5.5,0,0,1,0-.94,1.78,1.78,0,0,1,1.62,0A.5.5,0,0,1,55.25,61.34Z",
    transform: "translate(-3.44 -2)",
    fill: "#585859"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "46.71 56.74 46.05 56.36 46.6 56.03 47.27 56.42 46.71 56.74",
    fill: "#dcdadb"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "51.08 59.3 50.41 58.91 50.97 58.59 51.64 58.97 51.08 59.3",
    fill: "#dcdadb"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M32,88.39c0,.38-.13.69-.3.69s-.3-.31-.3-.69.14-.69.3-.69S32,88,32,88.39Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M32,90.44c0,.38-.13.69-.3.69s-.3-.31-.3-.69.14-.69.3-.69S32,90.06,32,90.44Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M32,92.48c0,.38-.13.69-.3.69s-.3-.31-.3-.69.14-.69.3-.69S32,92.1,32,92.48Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M32,94.53c0,.38-.13.69-.3.69s-.3-.31-.3-.69.14-.69.3-.69S32,94.15,32,94.53Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M32,96.57c0,.38-.13.69-.3.69s-.3-.31-.3-.69.14-.69.3-.69S32,96.19,32,96.57Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M32,98.62c0,.38-.13.69-.3.69s-.3-.31-.3-.69.14-.69.3-.69S32,98.24,32,98.62Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M32,100.66c0,.38-.13.69-.3.69s-.3-.31-.3-.69.14-.69.3-.69S32,100.28,32,100.66Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M32,102.71c0,.38-.13.69-.3.69s-.3-.31-.3-.69.14-.69.3-.69S32,102.33,32,102.71Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M32,104.75c0,.38-.13.69-.3.69s-.3-.31-.3-.69.14-.69.3-.69S32,104.37,32,104.75Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M32.75,91.88c0,.38-.13.69-.3.69s-.3-.31-.3-.69.13-.69.3-.69S32.75,91.5,32.75,91.88Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M32.75,93.93c0,.38-.13.69-.3.69s-.3-.31-.3-.69.13-.69.3-.69S32.75,93.55,32.75,93.93Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M32.75,96c0,.38-.13.69-.3.69s-.3-.31-.3-.69.13-.69.3-.69S32.75,95.6,32.75,96Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M32.75,98c0,.38-.13.69-.3.69s-.3-.31-.3-.69.13-.69.3-.69S32.75,97.65,32.75,98Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M32.75,100.08c0,.38-.13.69-.3.69s-.3-.31-.3-.69.13-.69.3-.69S32.75,99.7,32.75,100.08Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M32.75,102.12c0,.38-.13.69-.3.69s-.3-.31-.3-.69.13-.68.3-.68S32.75,101.74,32.75,102.12Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M32.75,104.17c0,.38-.13.69-.3.69s-.3-.31-.3-.69.13-.69.3-.69S32.75,103.79,32.75,104.17Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M32.75,106.22c0,.38-.13.69-.3.69s-.3-.31-.3-.69.13-.69.3-.69S32.75,105.84,32.75,106.22Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M33.53,91.27c0,.39-.14.69-.3.69s-.3-.3-.3-.69.13-.68.3-.68S33.53,90.89,33.53,91.27Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M33.53,93.32c0,.38-.14.69-.3.69s-.3-.31-.3-.69.13-.69.3-.69S33.53,92.94,33.53,93.32Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M33.53,95.36c0,.39-.14.69-.3.69s-.3-.3-.3-.69.13-.68.3-.68S33.53,95,33.53,95.36Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M33.53,97.41c0,.38-.14.69-.3.69s-.3-.31-.3-.69.13-.69.3-.69S33.53,97,33.53,97.41Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M33.53,99.45c0,.38-.14.69-.3.69s-.3-.31-.3-.69.13-.69.3-.69S33.53,99.07,33.53,99.45Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M33.53,101.5c0,.38-.14.69-.3.69s-.3-.31-.3-.69.13-.69.3-.69S33.53,101.12,33.53,101.5Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M33.53,103.54c0,.38-.14.69-.3.69s-.3-.31-.3-.69.13-.69.3-.69S33.53,103.16,33.53,103.54Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M33.53,105.59c0,.38-.14.69-.3.69s-.3-.31-.3-.69.13-.69.3-.69S33.53,105.21,33.53,105.59Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M33.53,107.63c0,.38-.14.69-.3.69s-.3-.31-.3-.69.13-.69.3-.69S33.53,107.25,33.53,107.63Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M34.43,92.88c0,.38-.15.69-.35.69s-.35-.31-.35-.69.16-.69.35-.69S34.43,92.5,34.43,92.88Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M34.43,94.93c0,.38-.15.68-.35.68s-.35-.3-.35-.68.16-.69.35-.69S34.43,94.55,34.43,94.93Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M34.43,97c0,.38-.15.69-.35.69s-.35-.31-.35-.69.16-.68.35-.68S34.43,96.59,34.43,97Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M34.43,99c0,.38-.15.69-.35.69s-.35-.31-.35-.69.16-.69.35-.69S34.43,98.64,34.43,99Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M34.43,101.07c0,.38-.15.69-.35.69s-.35-.31-.35-.69.16-.69.35-.69S34.43,100.69,34.43,101.07Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M34.43,103.12c0,.38-.15.69-.35.69s-.35-.31-.35-.69.16-.69.35-.69S34.43,102.74,34.43,103.12Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M34.43,105.17c0,.38-.15.69-.35.69s-.35-.31-.35-.69.16-.69.35-.69S34.43,104.79,34.43,105.17Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M34.43,107.22c0,.38-.15.69-.35.69s-.35-.31-.35-.69.16-.69.35-.69S34.43,106.84,34.43,107.22Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M35.34,92.57c0,.38-.16.69-.35.69s-.35-.31-.35-.69.15-.69.35-.69S35.34,92.19,35.34,92.57Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M35.34,94.62c0,.38-.16.69-.35.69s-.35-.31-.35-.69.15-.69.35-.69S35.34,94.24,35.34,94.62Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M35.34,96.66c0,.38-.16.69-.35.69s-.35-.31-.35-.69S34.79,96,35,96,35.34,96.28,35.34,96.66Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M35.34,98.71c0,.38-.16.68-.35.68s-.35-.3-.35-.68S34.79,98,35,98,35.34,98.33,35.34,98.71Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M35.34,100.75c0,.38-.16.69-.35.69s-.35-.31-.35-.69.15-.69.35-.69S35.34,100.37,35.34,100.75Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M35.34,102.8c0,.38-.16.68-.35.68s-.35-.3-.35-.68.15-.69.35-.69S35.34,102.41,35.34,102.8Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M35.34,104.84c0,.38-.16.69-.35.69s-.35-.31-.35-.69.15-.69.35-.69S35.34,104.46,35.34,104.84Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M35.34,106.89c0,.38-.16.68-.35.68s-.35-.3-.35-.68.15-.69.35-.69S35.34,106.5,35.34,106.89Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M35.34,108.93c0,.38-.16.69-.35.69s-.35-.31-.35-.69.15-.69.35-.69S35.34,108.55,35.34,108.93Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M36.61,94.56c0,.38-.22.69-.49.69s-.5-.31-.5-.69.22-.69.5-.69S36.61,94.18,36.61,94.56Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M36.61,96.61c0,.38-.22.69-.49.69s-.5-.31-.5-.69.22-.69.5-.69S36.61,96.23,36.61,96.61Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M36.61,98.66c0,.38-.22.69-.49.69s-.5-.31-.5-.69.22-.69.5-.69S36.61,98.28,36.61,98.66Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M36.61,100.71c0,.38-.22.69-.49.69s-.5-.31-.5-.69.22-.69.5-.69S36.61,100.33,36.61,100.71Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M36.61,102.76c0,.38-.22.68-.49.68s-.5-.3-.5-.68.22-.69.5-.69S36.61,102.37,36.61,102.76Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M36.61,104.8c0,.38-.22.69-.49.69s-.5-.31-.5-.69.22-.69.5-.69S36.61,104.42,36.61,104.8Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M36.61,106.85c0,.38-.22.69-.49.69s-.5-.31-.5-.69.22-.69.5-.69S36.61,106.47,36.61,106.85Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M36.61,108.9c0,.38-.22.69-.49.69s-.5-.31-.5-.69.22-.69.5-.69S36.61,108.52,36.61,108.9Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M37.88,93.82c0,.38-.22.69-.49.69s-.49-.31-.49-.69.22-.69.49-.69S37.88,93.44,37.88,93.82Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M37.88,95.86c0,.38-.22.69-.49.69s-.49-.31-.49-.69.22-.68.49-.68S37.88,95.48,37.88,95.86Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M37.88,97.91c0,.38-.22.69-.49.69s-.49-.31-.49-.69.22-.69.49-.69S37.88,97.53,37.88,97.91Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M37.88,100c0,.38-.22.69-.49.69s-.49-.31-.49-.69.22-.69.49-.69S37.88,99.57,37.88,100Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.95,
    cy: 100,
    rx: 0.49,
    ry: 0.69,
    fill: "#010101"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M37.88,104c0,.38-.22.69-.49.69s-.49-.31-.49-.69.22-.69.49-.69S37.88,103.66,37.88,104Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M37.88,106.09c0,.38-.22.69-.49.69s-.49-.31-.49-.69.22-.69.49-.69S37.88,105.71,37.88,106.09Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M37.88,108.13c0,.38-.22.69-.49.69s-.49-.31-.49-.69.22-.69.49-.69S37.88,107.75,37.88,108.13Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M37.88,110.18c0,.38-.22.69-.49.69s-.49-.31-.49-.69.22-.69.49-.69S37.88,109.8,37.88,110.18Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.22,
    cy: 93.5,
    rx: 0.49,
    ry: 0.69,
    fill: "#010101"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.22,
    cy: 95.55,
    rx: 0.49,
    ry: 0.69,
    fill: "#010101"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.22,
    cy: 97.6,
    rx: 0.49,
    ry: 0.69,
    fill: "#010101"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.22,
    cy: 99.65,
    rx: 0.49,
    ry: 0.69,
    fill: "#010101"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.22,
    cy: 101.7,
    rx: 0.49,
    ry: 0.69,
    fill: "#010101"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.22,
    cy: 103.75,
    rx: 0.49,
    ry: 0.69,
    fill: "#010101"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.22,
    cy: 105.79,
    rx: 0.49,
    ry: 0.69,
    fill: "#010101"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.22,
    cy: 107.84,
    rx: 0.49,
    ry: 0.69,
    fill: "#010101"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M40.93,95a.69.69,0,0,1-.69.69.69.69,0,0,1,0-1.38A.69.69,0,0,1,40.93,95Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M40.93,97a.69.69,0,0,1-.69.69.69.69,0,0,1,0-1.38A.69.69,0,0,1,40.93,97Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M40.93,99.09a.68.68,0,0,1-.69.68.67.67,0,0,1-.68-.68.68.68,0,0,1,.68-.69A.69.69,0,0,1,40.93,99.09Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M40.93,101.13a.69.69,0,0,1-.69.69.69.69,0,0,1,0-1.38A.69.69,0,0,1,40.93,101.13Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M40.93,103.18a.68.68,0,0,1-.69.68.69.69,0,0,1,0-1.37A.69.69,0,0,1,40.93,103.18Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M40.93,105.22a.69.69,0,0,1-.69.69.69.69,0,0,1,0-1.38A.69.69,0,0,1,40.93,105.22Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M40.93,107.26a.69.69,0,0,1-.69.69.69.69,0,1,1,.69-.69Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M40.93,109.31a.69.69,0,0,1-.69.69.69.69,0,0,1,0-1.38A.69.69,0,0,1,40.93,109.31Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.8,
    cy: 109.35,
    r: 0.69,
    fill: "#010101"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M42.71,96.68A.69.69,0,1,1,42,96,.69.69,0,0,1,42.71,96.68Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M42.71,98.73A.69.69,0,1,1,42,98,.69.69,0,0,1,42.71,98.73Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M42.71,100.78a.69.69,0,1,1-.69-.69A.69.69,0,0,1,42.71,100.78Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M42.71,102.83a.69.69,0,0,1-1.38,0,.69.69,0,1,1,1.38,0Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M42.71,104.87a.69.69,0,1,1-.69-.69A.69.69,0,0,1,42.71,104.87Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M42.71,106.92a.69.69,0,1,1-.69-.69A.69.69,0,0,1,42.71,106.92Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M42.71,109a.69.69,0,1,1-.69-.69A.69.69,0,0,1,42.71,109Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M42.71,111a.69.69,0,1,1-.69-.69A.69.69,0,0,1,42.71,111Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.35,
    cy: 93.69,
    r: 0.69,
    fill: "#010101"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.35,
    cy: 95.73,
    r: 0.69,
    fill: "#010101"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.35,
    cy: 97.77,
    r: 0.69,
    fill: "#010101"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.35,
    cy: 99.82,
    r: 0.69,
    fill: "#010101"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.35,
    cy: 101.86,
    r: 0.69,
    fill: "#010101"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.35,
    cy: 103.91,
    r: 0.69,
    fill: "#010101"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.35,
    cy: 105.95,
    r: 0.69,
    fill: "#010101"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.35,
    cy: 108,
    r: 0.69,
    fill: "#010101"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.35,
    cy: 110.04,
    r: 0.69,
    fill: "#010101"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M46.26,97.06a.69.69,0,1,1-.69-.69A.69.69,0,0,1,46.26,97.06Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M46.26,99.11a.69.69,0,1,1-.69-.69A.69.69,0,0,1,46.26,99.11Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M46.26,101.16a.69.69,0,1,1-.69-.69A.69.69,0,0,1,46.26,101.16Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M46.26,103.21a.69.69,0,1,1-.69-.69A.69.69,0,0,1,46.26,103.21Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M46.26,105.26a.69.69,0,1,1-.69-.69A.69.69,0,0,1,46.26,105.26Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M46.26,107.3a.69.69,0,1,1-.69-.68A.69.69,0,0,1,46.26,107.3Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M46.26,109.35a.69.69,0,1,1-.69-.69A.69.69,0,0,1,46.26,109.35Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M46.26,111.4a.69.69,0,1,1-.69-.69A.69.69,0,0,1,46.26,111.4Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.9,
    cy: 94.07,
    r: 0.69,
    fill: "#010101"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.9,
    cy: 96.11,
    r: 0.69,
    fill: "#010101"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.9,
    cy: 98.16,
    r: 0.69,
    fill: "#010101"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.9,
    cy: 100.2,
    r: 0.69,
    fill: "#010101"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.9,
    cy: 102.25,
    r: 0.69,
    fill: "#010101"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.9,
    cy: 104.29,
    r: 0.69,
    fill: "#010101"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.9,
    cy: 106.34,
    r: 0.69,
    fill: "#010101"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.9,
    cy: 108.38,
    r: 0.69,
    fill: "#010101"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.9,
    cy: 110.43,
    r: 0.69,
    fill: "#010101"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M49.81,97.06a.69.69,0,1,1-.69-.69A.69.69,0,0,1,49.81,97.06Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M49.81,99.11a.69.69,0,1,1-.69-.69A.69.69,0,0,1,49.81,99.11Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M49.81,101.16a.69.69,0,1,1-.69-.69A.69.69,0,0,1,49.81,101.16Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M49.81,103.21a.69.69,0,1,1-.69-.69A.69.69,0,0,1,49.81,103.21Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M49.81,105.26a.69.69,0,1,1-.69-.69A.69.69,0,0,1,49.81,105.26Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M49.81,107.3a.69.69,0,1,1-.69-.68A.69.69,0,0,1,49.81,107.3Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M49.81,109.35a.69.69,0,1,1-.69-.69A.69.69,0,0,1,49.81,109.35Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M49.81,111.4a.69.69,0,1,1-.69-.69A.69.69,0,0,1,49.81,111.4Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M51.58,95.69a.69.69,0,1,1-.69-.69A.68.68,0,0,1,51.58,95.69Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M51.58,97.73a.69.69,0,1,1-.69-.69A.69.69,0,0,1,51.58,97.73Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M51.58,99.77a.69.69,0,1,1-.69-.68A.69.69,0,0,1,51.58,99.77Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M51.58,101.82a.69.69,0,1,1-.69-.69A.69.69,0,0,1,51.58,101.82Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M51.58,103.86a.69.69,0,1,1-.69-.68A.69.69,0,0,1,51.58,103.86Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M51.58,105.91a.69.69,0,1,1-.69-.69A.69.69,0,0,1,51.58,105.91Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M51.58,108a.69.69,0,1,1-.69-.69A.69.69,0,0,1,51.58,108Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M51.58,110a.69.69,0,1,1-.69-.69A.69.69,0,0,1,51.58,110Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M51.58,112a.69.69,0,1,1-.69-.69A.69.69,0,0,1,51.58,112Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M53.26,96.68a.64.64,0,1,1-.64-.69A.67.67,0,0,1,53.26,96.68Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M53.26,98.73a.64.64,0,1,1-.64-.69A.67.67,0,0,1,53.26,98.73Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M53.26,100.78a.64.64,0,1,1-.64-.69A.67.67,0,0,1,53.26,100.78Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M53.26,102.83a.64.64,0,1,1-.64-.69A.67.67,0,0,1,53.26,102.83Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M53.26,104.87a.64.64,0,1,1-.64-.69A.67.67,0,0,1,53.26,104.87Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M53.26,106.92a.64.64,0,1,1-.64-.69A.67.67,0,0,1,53.26,106.92Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M53.26,109a.64.64,0,1,1-.64-.69A.67.67,0,0,1,53.26,109Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.18,
    cy: 109.02,
    rx: 0.64,
    ry: 0.69,
    fill: "#010101"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7,95a.56.56,0,1,1-.54-.69A.63.63,0,0,1,54.7,95Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7,97a.56.56,0,1,1-.54-.69A.63.63,0,0,1,54.7,97Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7,99.09a.55.55,0,1,1-1.08,0,.56.56,0,1,1,1.08,0Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7,101.13a.56.56,0,1,1-.54-.69A.63.63,0,0,1,54.7,101.13Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7,103.18a.56.56,0,1,1-.54-.69A.62.62,0,0,1,54.7,103.18Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7,105.22a.56.56,0,1,1-.54-.69A.63.63,0,0,1,54.7,105.22Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7,107.26a.55.55,0,1,1-.54-.68A.62.62,0,0,1,54.7,107.26Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7,109.31a.56.56,0,1,1-.54-.69A.63.63,0,0,1,54.7,109.31Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7,111.35a.55.55,0,1,1-.54-.68A.62.62,0,0,1,54.7,111.35Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M56.08,95.5a.55.55,0,1,1-.53-.69A.63.63,0,0,1,56.08,95.5Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M56.08,97.55a.55.55,0,1,1-.53-.69A.63.63,0,0,1,56.08,97.55Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M56.08,99.6a.55.55,0,1,1-.53-.69A.63.63,0,0,1,56.08,99.6Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M56.08,101.65a.55.55,0,1,1-.53-.69A.63.63,0,0,1,56.08,101.65Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M56.08,103.7a.55.55,0,1,1-.53-.69A.63.63,0,0,1,56.08,103.7Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M56.08,105.75a.55.55,0,1,1-1.07,0,.55.55,0,1,1,1.07,0Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M56.08,107.79a.55.55,0,1,1-.53-.69A.63.63,0,0,1,56.08,107.79Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M56.08,109.84a.55.55,0,1,1-.53-.69A.63.63,0,0,1,56.08,109.84Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M57.47,93.82a.56.56,0,1,1-.54-.69A.63.63,0,0,1,57.47,93.82Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M57.47,95.86a.56.56,0,1,1-1.08,0,.55.55,0,1,1,1.08,0Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M57.47,97.91a.56.56,0,1,1-.54-.69A.63.63,0,0,1,57.47,97.91Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M57.47,100a.56.56,0,1,1-.54-.69A.63.63,0,0,1,57.47,100Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.49,
    cy: 100,
    rx: 0.54,
    ry: 0.69,
    fill: "#010101"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M57.47,104a.56.56,0,1,1-.54-.69A.63.63,0,0,1,57.47,104Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M57.47,106.09a.56.56,0,1,1-.54-.69A.63.63,0,0,1,57.47,106.09Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M57.47,108.13a.56.56,0,1,1-.54-.69A.63.63,0,0,1,57.47,108.13Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M57.47,110.18a.56.56,0,1,1-.54-.69A.63.63,0,0,1,57.47,110.18Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M58.63,94.56c0,.38-.19.69-.42.69s-.43-.31-.43-.69.19-.69.43-.69S58.63,94.18,58.63,94.56Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M58.63,96.61c0,.38-.19.69-.42.69s-.43-.31-.43-.69.19-.69.43-.69S58.63,96.23,58.63,96.61Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M58.63,98.66c0,.38-.19.69-.42.69s-.43-.31-.43-.69S58,98,58.21,98,58.63,98.28,58.63,98.66Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M58.63,100.71c0,.38-.19.69-.42.69s-.43-.31-.43-.69.19-.69.43-.69S58.63,100.33,58.63,100.71Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M58.63,102.76c0,.38-.19.68-.42.68s-.43-.3-.43-.68.19-.69.43-.69S58.63,102.37,58.63,102.76Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M58.63,104.8c0,.38-.19.69-.42.69s-.43-.31-.43-.69.19-.69.43-.69S58.63,104.42,58.63,104.8Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M58.63,106.85c0,.38-.19.69-.42.69s-.43-.31-.43-.69.19-.69.43-.69S58.63,106.47,58.63,106.85Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M58.63,108.9c0,.38-.19.69-.42.69s-.43-.31-.43-.69.19-.69.43-.69S58.63,108.52,58.63,108.9Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.87,
    cy: 90.57,
    rx: 0.43,
    ry: 0.69,
    fill: "#010101"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M59.74,94.62c0,.38-.19.69-.43.69s-.43-.31-.43-.69.19-.69.43-.69S59.74,94.24,59.74,94.62Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M59.74,96.66c0,.38-.19.69-.43.69s-.43-.31-.43-.69.19-.69.43-.69S59.74,96.28,59.74,96.66Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M59.74,98.71c0,.38-.19.68-.43.68s-.43-.3-.43-.68.19-.69.43-.69S59.74,98.33,59.74,98.71Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M59.74,100.75c0,.38-.19.69-.43.69s-.43-.31-.43-.69.19-.69.43-.69S59.74,100.37,59.74,100.75Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M59.74,102.8c0,.38-.19.68-.43.68s-.43-.3-.43-.68.19-.69.43-.69S59.74,102.41,59.74,102.8Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M59.74,104.84c0,.38-.19.69-.43.69s-.43-.31-.43-.69.19-.69.43-.69S59.74,104.46,59.74,104.84Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M59.74,106.89c0,.38-.19.68-.43.68s-.43-.3-.43-.68.19-.69.43-.69S59.74,106.5,59.74,106.89Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M59.74,108.93c0,.38-.19.69-.43.69s-.43-.31-.43-.69.19-.69.43-.69S59.74,108.55,59.74,108.93Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M60.61,92.88c0,.38-.14.69-.31.69s-.32-.31-.32-.69.15-.69.32-.69S60.61,92.5,60.61,92.88Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M60.61,94.93c0,.38-.14.68-.31.68s-.32-.3-.32-.68.15-.69.32-.69S60.61,94.55,60.61,94.93Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M60.61,97c0,.38-.14.69-.31.69S60,97.35,60,97s.15-.68.32-.68S60.61,96.59,60.61,97Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M60.61,99c0,.38-.14.69-.31.69S60,99.4,60,99s.15-.69.32-.69S60.61,98.64,60.61,99Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M60.61,101.07c0,.38-.14.69-.31.69s-.32-.31-.32-.69.15-.69.32-.69S60.61,100.69,60.61,101.07Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M60.61,103.12c0,.38-.14.69-.31.69s-.32-.31-.32-.69.15-.69.32-.69S60.61,102.74,60.61,103.12Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M60.61,105.17c0,.38-.14.69-.31.69s-.32-.31-.32-.69.15-.69.32-.69S60.61,104.79,60.61,105.17Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.86,
    cy: 105.22,
    rx: 0.32,
    ry: 0.69,
    fill: "#010101"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M61.43,91.27c0,.39-.14.69-.32.69s-.31-.3-.31-.69.14-.68.31-.68S61.43,90.89,61.43,91.27Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M61.43,93.32c0,.38-.14.69-.32.69s-.31-.31-.31-.69.14-.69.31-.69S61.43,92.94,61.43,93.32Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M61.43,95.36c0,.39-.14.69-.32.69s-.31-.3-.31-.69.14-.68.31-.68S61.43,95,61.43,95.36Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M61.43,97.41c0,.38-.14.69-.32.69s-.31-.31-.31-.69.14-.69.31-.69S61.43,97,61.43,97.41Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M61.43,99.45c0,.38-.14.69-.32.69s-.31-.31-.31-.69.14-.69.31-.69S61.43,99.07,61.43,99.45Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M61.43,101.5c0,.38-.14.69-.32.69s-.31-.31-.31-.69.14-.69.31-.69S61.43,101.12,61.43,101.5Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M61.43,103.54c0,.38-.14.69-.32.69s-.31-.31-.31-.69.14-.69.31-.69S61.43,103.16,61.43,103.54Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M61.43,105.59c0,.38-.14.69-.32.69s-.31-.31-.31-.69.14-.69.31-.69S61.43,105.21,61.43,105.59Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M61.43,107.63c0,.38-.14.69-.32.69s-.31-.31-.31-.69.14-.69.31-.69S61.43,107.25,61.43,107.63Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.48,
    cy: 89.88,
    rx: 0.32,
    ry: 0.69,
    fill: "#010101"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M62.24,93.93c0,.38-.14.69-.32.69s-.31-.31-.31-.69.14-.69.31-.69S62.24,93.55,62.24,93.93Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M62.24,96c0,.38-.14.69-.32.69s-.31-.31-.31-.69.14-.69.31-.69S62.24,95.6,62.24,96Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M62.24,98c0,.38-.14.69-.32.69s-.31-.31-.31-.69.14-.69.31-.69S62.24,97.65,62.24,98Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M62.24,100.08c0,.38-.14.69-.32.69s-.31-.31-.31-.69.14-.69.31-.69S62.24,99.7,62.24,100.08Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M62.24,102.12c0,.38-.14.69-.32.69s-.31-.31-.31-.69.14-.68.31-.68S62.24,101.74,62.24,102.12Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M62.24,104.17c0,.38-.14.69-.32.69s-.31-.31-.31-.69.14-.69.31-.69S62.24,103.79,62.24,104.17Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M62.24,106.22c0,.38-.14.69-.32.69s-.31-.31-.31-.69.14-.69.31-.69S62.24,105.84,62.24,106.22Z",
    transform: "translate(-3.44 -2)",
    fill: "#010101"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.29,
    cy: 86.39,
    rx: 0.32,
    ry: 0.69,
    fill: "#010101"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.29,
    cy: 88.44,
    rx: 0.32,
    ry: 0.69,
    fill: "#010101"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.29,
    cy: 90.48,
    rx: 0.32,
    ry: 0.69,
    fill: "#010101"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.29,
    cy: 92.53,
    rx: 0.32,
    ry: 0.69,
    fill: "#010101"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.29,
    cy: 94.57,
    rx: 0.32,
    ry: 0.69,
    fill: "#010101"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.29,
    cy: 96.62,
    rx: 0.32,
    ry: 0.69,
    fill: "#010101"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.29,
    cy: 98.66,
    rx: 0.32,
    ry: 0.69,
    fill: "#010101"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.29,
    cy: 100.71,
    rx: 0.32,
    ry: 0.69,
    fill: "#010101"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.29,
    cy: 102.75,
    rx: 0.32,
    ry: 0.69,
    fill: "#010101"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M58.13,84.27v.51l-1.51.92v-.52a1.86,1.86,0,0,1,.76-1.46.45.45,0,0,1,.53,0A.68.68,0,0,1,58.13,84.27Z",
    transform: "translate(-3.44 -2)",
    fill: "#48484a"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M56.62,85.89,58.13,85v.42a1.9,1.9,0,0,1-.75,1.47c-.42.25-.76,0-.76-.55Z",
    transform: "translate(-3.44 -2)",
    fill: "#48484a"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M56.36,86.12a.52.52,0,0,1-.2.4c-.12.07-.21,0-.21-.15a.49.49,0,0,1,.21-.4C56.27,85.9,56.36,86,56.36,86.12Z",
    transform: "translate(-3.44 -2)",
    fill: "#48484a"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8,84.63a.51.51,0,0,1-.2.4c-.11.07-.2,0-.2-.15a.52.52,0,0,1,.2-.4C58.71,84.41,58.8,84.48,58.8,84.63Z",
    transform: "translate(-3.44 -2)",
    fill: "#48484a"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "54.1 86.21 53.77 86.41 53.77 85.28 54.1 85.08 54.1 86.21",
    fill: "#48484a"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "54.4 85.86 54.4 86.36 53.47 86.92 53.47 86.43 54.4 85.86",
    fill: "#48484a"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M57.38,87.38c-.43.26-.76.29-1,.1-.39-.32-.34-1.15-.34-1.18l.21-.11s0,.74.28,1,.47.13.84-.1Z",
    transform: "translate(-3.44 -2)",
    fill: "#48484a"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M57.38,87.38V87.1a2.18,2.18,0,0,0,.83-.92,3,3,0,0,0,.28-1.35l.21-.15a3.53,3.53,0,0,1-.33,1.6A2.71,2.71,0,0,1,57.38,87.38Z",
    transform: "translate(-3.44 -2)",
    fill: "#48484a"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.36,
    cy: 66.55,
    r: 22.41,
    fill: "none",
    stroke: "#ef5182",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    strokeDasharray: "2.01 2.01"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.58,
    cy: 144.34,
    r: 22.41,
    fill: "none",
    stroke: "#ef5182",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    strokeDasharray: "2.01 2.01"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M37.52,18.78c-.34,0-.69-.41-1-1.2a10.07,10.07,0,0,1-.59-1.76c-.32,0-.84.09-1.57.14a14.72,14.72,0,0,0-1.56.17c-.2.47-.55,1.19-1,2.14a.88.88,0,0,1-.79.47.92.92,0,0,1-.64-.25.75.75,0,0,1-.28-.61A9.73,9.73,0,0,1,31,15.64a.79.79,0,0,1-.08-.38q0-.31.63-.48c.61-1.07,1.29-2.17,2.05-3.3C34.63,9.84,35.3,9,35.55,9c.47,0,.79.29,1,.86s.22,1.16.41,2.08c.26,1.24.58,2.66,1,4.27a8.49,8.49,0,0,0,.33.85,2.39,2.39,0,0,1,.24.83.82.82,0,0,1-.29.63A.85.85,0,0,1,37.52,18.78ZM35.1,12.14c-.33.58-.8,1.37-1.39,2.36a8.26,8.26,0,0,1,.91-.1l.91-.07C35.43,13.77,35.28,13,35.1,12.14Z",
    transform: "translate(-3.44 -2)",
    fill: "#fff"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2,13.92c0,.66-.33,1-.89,1a.73.73,0,0,1-.82-.84l0-.65a2.66,2.66,0,0,0-2.09,1.49v3.26a.81.81,0,0,1-.25.61.89.89,0,0,1-.64.24.76.76,0,0,1-.62-.26.84.84,0,0,1-.21-.59V13.93c0-.14,0-.34,0-.6s0-.47,0-.6a.89.89,0,0,1,.22-.6.77.77,0,0,1,.62-.25.79.79,0,0,1,.85.74,4.18,4.18,0,0,1,2.55-.85c.86,0,1.29.57,1.29,1.72A4.26,4.26,0,0,1,45.2,13.92Z",
    transform: "translate(-3.44 -2)",
    fill: "#fff"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M49.41,18.89a4.13,4.13,0,0,1-2.53-.74,2.73,2.73,0,0,1-1.09-2.3,4.46,4.46,0,0,1,.86-2.77,3.08,3.08,0,0,1,2.59-1.26,4.29,4.29,0,0,1,1.87.37,1.52,1.52,0,0,1,.18,2.75,10.73,10.73,0,0,1-1.46.74l-2.18,1a2,2,0,0,0,.75.5,2.68,2.68,0,0,0,1,.17A2.91,2.91,0,0,0,50.88,17a1.91,1.91,0,0,1,.86-.32.58.58,0,0,1,.67.65c0,.49-.36.9-1.08,1.21A4.78,4.78,0,0,1,49.41,18.89Zm-.17-5.5a1.43,1.43,0,0,0-1,.4A2.74,2.74,0,0,0,47.52,15c.49-.22,1-.43,1.46-.63a13,13,0,0,0,1.39-.73A2.23,2.23,0,0,0,49.24,13.39Z",
    transform: "translate(-3.44 -2)",
    fill: "#fff"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M65.74,13.12q-.7,1.47-2.23,4.61c-.56,1.13-1,2.06-1.27,2.81l-.42,1.19a.84.84,0,0,1-.83.6,1,1,0,0,1-.65-.23.8.8,0,0,1-.28-.61,14.72,14.72,0,0,1,1.38-3.56q-.72-1.41-2.26-4.14c-.11-.16-.21-.33-.32-.5a1,1,0,0,1-.17-.54.86.86,0,0,1,.27-.62.93.93,0,0,1,.64-.26.79.79,0,0,1,.67.32,24.26,24.26,0,0,1,2.14,3.68c.46-1,.75-1.64.84-1.85.31-.64.61-1.21.9-1.7a.86.86,0,0,1,.77-.46,1,1,0,0,1,.65.24.78.78,0,0,1,.28.6A1,1,0,0,1,65.74,13.12Z",
    transform: "translate(-3.44 -2)",
    fill: "#fff"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3,19a2.88,2.88,0,0,1-2.06-.82,3.3,3.3,0,0,1-1-2.4A3.94,3.94,0,0,1,67,13.2a3.23,3.23,0,0,1,2.74-1.32,2.43,2.43,0,0,1,2.06,1,3.77,3.77,0,0,1,.69,2.31,4.08,4.08,0,0,1-.81,2.56A2.87,2.87,0,0,1,69.3,19Zm.39-5.39a1.42,1.42,0,0,0-1.26.73A2.63,2.63,0,0,0,68,15.75a1.58,1.58,0,0,0,.44,1.19,1.17,1.17,0,0,0,.82.33,1.44,1.44,0,0,0,1-.38,1.72,1.72,0,0,0,.5-1.21C70.84,14.29,70.47,13.59,69.69,13.58Z",
    transform: "translate(-3.44 -2)",
    fill: "#fff"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M79.27,14.85c0,.29,0,.72,0,1.3s0,1,0,1.31a3.51,3.51,0,0,0,0,.41c0,.17,0,.31,0,.4a.79.79,0,0,1-.26.6.93.93,0,0,1-.65.23.83.83,0,0,1-.78-.48,5,5,0,0,1-1.71.3,2.87,2.87,0,0,1-1.55-.38,1.8,1.8,0,0,1-.84-1.3,18.47,18.47,0,0,1-.25-2.87,10.89,10.89,0,0,1,.19-1.92.8.8,0,0,1,.87-.72A1,1,0,0,1,75,12a.77.77,0,0,1,.27.6,6.74,6.74,0,0,1-.09.88,5.79,5.79,0,0,0-.1.92c0,.61,0,1.13.06,1.59a6.62,6.62,0,0,0,.19,1.12l.31.11a1.54,1.54,0,0,0,.3,0A6.75,6.75,0,0,0,77.51,17c0-.33,0-.71,0-1.13s0-.87,0-1.09a18.75,18.75,0,0,1,.12-2.29.79.79,0,0,1,.88-.77,1,1,0,0,1,.65.24.73.73,0,0,1,.26.6C79.31,14.21,79.27,15,79.27,14.85Z",
    transform: "translate(-3.44 -2)",
    fill: "#fff"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M89.56,21.29l-.56,0-.57,0-.44,0-.43,0c-.73,0-1.1-.33-1.1-1s0-1.94,0-3.49,0-2.71,0-3.48c0-.42,0-1.05,0-1.88s0-1.46,0-1.88A.76.76,0,0,1,86.73,9a1,1,0,0,1,.65-.24l.66,0h1l.37,0a.84.84,0,0,1,.62.24.8.8,0,0,1,.23.61c0,.6-.52.89-1.56.89H88.2v9.08H89c.28,0,.46,0,.57,0a.78.78,0,0,1,.59.25.81.81,0,0,1,.24.6.84.84,0,0,1-.24.61A.78.78,0,0,1,89.56,21.29Z",
    transform: "translate(-3.44 -2)",
    fill: "#fff"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M96.68,18.85a.83.83,0,0,1-.78-.49A9.92,9.92,0,0,0,95,17c-.66-.83-1-1.28-1-1.33-.35.26-.63.45-.86.59C93,16.82,93,17.4,93,18a.84.84,0,0,1-.26.62.88.88,0,0,1-.64.24c-.6,0-.91-.36-.91-1.08,0-.34,0-.85.08-1.53s.07-1.19.07-1.53c0-.63,0-1.35,0-2.15s0-1.52,0-2.13q0-.29,0-.66t0-.66a.79.79,0,0,1,.25-.61.86.86,0,0,1,.64-.25.84.84,0,0,1,.64.25.8.8,0,0,1,.26.61c0,.19,0,.42,0,.68s0,.48,0,.67c0,.51,0,1.12,0,1.83s0,1.27,0,1.79a30.85,30.85,0,0,0,2.68-2.47.88.88,0,0,1,.65-.28.93.93,0,0,1,.64.26.85.85,0,0,1,.28.62.83.83,0,0,1-.26.57,20.73,20.73,0,0,1-1.82,1.79l1.35,1.73a4.33,4.33,0,0,1,1,1.74.76.76,0,0,1-.29.6A.92.92,0,0,1,96.68,18.85Z",
    transform: "translate(-3.44 -2)",
    fill: "#fff"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M103.49,19.05a.8.8,0,0,1-.89-.79l-.18-1.34a10.64,10.64,0,0,1-.09-1.34c0-.11,0-.3,0-.57s0-.47,0-.58,0-.1,0-.23,0-.22,0-.3c0-.36-.09-.54-.26-.54a1.45,1.45,0,0,0-1.09.72,5.18,5.18,0,0,0-.83,1.8c0,.15,0,.34-.06.59s0,.39,0,.58a4.93,4.93,0,0,1,0,.56,4.93,4.93,0,0,0,0,.56.82.82,0,0,1-.26.63.94.94,0,0,1-1.28,0,.83.83,0,0,1-.25-.62,4.79,4.79,0,0,0,0-.56,4.79,4.79,0,0,1,0-.56c0-.42,0-1,.09-1.76s.09-1.33.09-1.76c0-.13,0-.32,0-.59s0-.45,0-.58a.77.77,0,0,1,.26-.61.91.91,0,0,1,.64-.24c.57,0,.87.34.91,1v.07a2.79,2.79,0,0,1,2-.95,1.7,1.7,0,0,1,1.69,1,5.34,5.34,0,0,1,.31,2.05v.46c0,.2,0,.34,0,.42a8.15,8.15,0,0,0,.14,1.3,8.15,8.15,0,0,1,.14,1.3.79.79,0,0,1-.26.6A.91.91,0,0,1,103.49,19.05Z",
    transform: "translate(-3.44 -2)",
    fill: "#fff"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M107.35,15.55c0,.25,0,.64,0,1.19s0,.93,0,1.18a.81.81,0,0,1-.25.62.91.91,0,0,1-.64.24.88.88,0,0,1-.64-.24.82.82,0,0,1-.26-.62c0-.25,0-.64,0-1.18s0-.94,0-1.19,0-.86.06-1.44.07-1.06.07-1.44a.81.81,0,0,1,.25-.62.94.94,0,0,1,1.28,0,.81.81,0,0,1,.25.62q0,.57-.06,1.44C107.38,14.69,107.35,15.17,107.35,15.55Zm-.55-4.74a1,1,0,0,1-.71-.28.9.9,0,0,1,0-1.36,1.05,1.05,0,0,1,1.43,0,.92.92,0,0,1,0,1.36A1,1,0,0,1,106.8,10.81Z",
    transform: "translate(-3.44 -2)",
    fill: "#fff"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M113.61,13.38H113a4.82,4.82,0,0,0-.61.05c.07,1.74.11,2.88.11,3.42,0,.05,0,.16,0,.31s0,.28,0,.37c0,1-.32,1.49-.94,1.49a.92.92,0,0,1-.62-.22.71.71,0,0,1-.28-.58c0-.16,0-.39,0-.7s0-.54,0-.7c0-.52,0-1.64-.12-3.35-.27,0-.67,0-1.21-.11s-.82-.34-.82-.84a.86.86,0,0,1,.25-.61.84.84,0,0,1,.64-.25c.15,0,.52,0,1.1.07,0-.13,0-.36,0-.68s0-.49,0-.64a.79.79,0,0,1,.26-.6.93.93,0,0,1,.64-.24c.64,0,1,.53,1,1.61v.53a4.58,4.58,0,0,1,.65-.06,3.31,3.31,0,0,1,1,.1.75.75,0,0,1,.52.79.82.82,0,0,1-.26.61A.86.86,0,0,1,113.61,13.38Z",
    transform: "translate(-3.44 -2)",
    fill: "#fff"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M119.86,13.38h-.64a5,5,0,0,0-.62.05q.12,2.61.12,3.42v.31c0,.15,0,.28,0,.37,0,1-.31,1.49-.94,1.49a.9.9,0,0,1-.61-.22.72.72,0,0,1-.29-.58c0-.16,0-.39,0-.7s0-.54,0-.7c0-.52,0-1.64-.11-3.35-.27,0-.68,0-1.22-.11a.78.78,0,0,1-.81-.84.85.85,0,0,1,.88-.86c.16,0,.53,0,1.1.07,0-.13,0-.36,0-.68s0-.49,0-.64a.77.77,0,0,1,.27-.6.91.91,0,0,1,.64-.24c.64,0,1,.53,1,1.61l0,.53a4.7,4.7,0,0,1,.66-.06,3.28,3.28,0,0,1,1,.1.74.74,0,0,1,.52.79.81.81,0,0,1-.25.61A.86.86,0,0,1,119.86,13.38Z",
    transform: "translate(-3.44 -2)",
    fill: "#fff"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M123.56,15.55c0,.25,0,.64,0,1.19s0,.93,0,1.18a.81.81,0,0,1-.25.62,1,1,0,0,1-1.28,0,.81.81,0,0,1-.25-.62c0-.25,0-.64,0-1.18s0-.94,0-1.19,0-.86.07-1.44.06-1.06.06-1.44a.85.85,0,0,1,.25-.62,1,1,0,0,1,1.29,0,.85.85,0,0,1,.25.62c0,.38,0,.86-.07,1.44S123.56,15.17,123.56,15.55ZM123,10.81a1,1,0,0,1-.72-.28.92.92,0,0,1,0-1.36,1.05,1.05,0,0,1,1.43,0,.9.9,0,0,1,0,1.36A1,1,0,0,1,123,10.81Z",
    transform: "translate(-3.44 -2)",
    fill: "#fff"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M130.35,19.05a.8.8,0,0,1-.89-.79l-.18-1.34a10.73,10.73,0,0,1-.1-1.34q0-.16,0-.57c0-.27,0-.47,0-.58s0-.1,0-.23,0-.22,0-.3c0-.36-.08-.54-.25-.54a1.43,1.43,0,0,0-1.09.72,5.19,5.19,0,0,0-.84,1.8,5.36,5.36,0,0,1,0,.59,3.86,3.86,0,0,0,0,.58,4.93,4.93,0,0,1,0,.56,4.93,4.93,0,0,0,0,.56.86.86,0,0,1-.26.63.94.94,0,0,1-1.28,0,.83.83,0,0,1-.25-.62c0-.13,0-.31,0-.56a4.79,4.79,0,0,1,0-.56c0-.42,0-1,.09-1.76s.09-1.33.09-1.76c0-.13,0-.32,0-.59s0-.45,0-.58a.78.78,0,0,1,.27-.61.91.91,0,0,1,.64-.24c.57,0,.87.34.91,1v.07a2.79,2.79,0,0,1,2-.95,1.71,1.71,0,0,1,1.69,1,5.34,5.34,0,0,1,.31,2.05v.46c0,.2,0,.34,0,.42a8.15,8.15,0,0,0,.14,1.3,8.15,8.15,0,0,1,.14,1.3.79.79,0,0,1-.26.6A.91.91,0,0,1,130.35,19.05Z",
    transform: "translate(-3.44 -2)",
    fill: "#fff"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M138.19,14.73a21.51,21.51,0,0,0-.33,3.21,5.85,5.85,0,0,1-.7,3,3.34,3.34,0,0,1-3,1.26c-1.68,0-2.52-.33-2.52-1a.75.75,0,0,1,.23-.57.81.81,0,0,1,.59-.23,4.82,4.82,0,0,1,.84.11,4.48,4.48,0,0,0,1,.12,1.71,1.71,0,0,0,1.43-.59,3.54,3.54,0,0,0,.52-1.84,2.09,2.09,0,0,1-.75.51,2.46,2.46,0,0,1-.91.17,2.78,2.78,0,0,1-2.09-.84,3,3,0,0,1-.8-2.15,3.84,3.84,0,0,1,1.07-2.84,4,4,0,0,1,3-1.13,3.32,3.32,0,0,1,1,.15,1.67,1.67,0,0,1,.71.45.86.86,0,0,1,.82,1A7.25,7.25,0,0,1,138.19,14.73Zm-2.52-1.29a2.15,2.15,0,0,0-1.7.71,2.6,2.6,0,0,0-.54,1.7,2,2,0,0,0,.29,1.16,1,1,0,0,0,.87.39,1.48,1.48,0,0,0,1.07-.62,2.21,2.21,0,0,0,.58-1.15c.08-.41.17-1.06.28-1.94a2,2,0,0,0-.43-.19A1.52,1.52,0,0,0,135.67,13.44Z",
    transform: "translate(-3.44 -2)",
    fill: "#fff"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M139.2,21a.84.84,0,0,1-.24-.61.81.81,0,0,1,.24-.6.78.78,0,0,1,.58-.25c.11,0,.3,0,.57,0h.8V10.48h-.53c-1.05,0-1.57-.29-1.57-.89a.81.81,0,0,1,.24-.61.83.83,0,0,1,.62-.24l.36,0h1l.67,0a.94.94,0,0,1,.64.24.74.74,0,0,1,.28.59c0,.42,0,1.05,0,1.88s0,1.46,0,1.88c0,.77,0,1.93,0,3.48s0,2.71,0,3.49-.36,1-1.09,1l-.44,0-.43,0-.57,0-.57,0A.78.78,0,0,1,139.2,21Z",
    transform: "translate(-3.44 -2)",
    fill: "#fff"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M155.06,19.05a.8.8,0,0,1-.89-.79L154,16.92a10.73,10.73,0,0,1-.1-1.34q0-.16,0-.57c0-.27,0-.47,0-.58s0-.1,0-.23,0-.22,0-.3c0-.36-.08-.54-.26-.54a1.44,1.44,0,0,0-1.08.72,5.19,5.19,0,0,0-.84,1.8c0,.15,0,.34-.05.59a3.86,3.86,0,0,0,0,.58,4.93,4.93,0,0,1,0,.56,4.93,4.93,0,0,0,0,.56.86.86,0,0,1-.26.63.94.94,0,0,1-1.28,0,.83.83,0,0,1-.25-.62c0-.13,0-.31,0-.56a4.79,4.79,0,0,1,0-.56c0-.42,0-1,.09-1.76s.09-1.33.09-1.76c0-.13,0-.32,0-.59s0-.45,0-.58a.78.78,0,0,1,.27-.61.91.91,0,0,1,.64-.24c.56,0,.87.34.91,1v.07a2.79,2.79,0,0,1,2-.95,1.69,1.69,0,0,1,1.68,1,5.12,5.12,0,0,1,.32,2.05v.46c0,.2,0,.34,0,.42a8.15,8.15,0,0,0,.14,1.3,8.15,8.15,0,0,1,.14,1.3.79.79,0,0,1-.26.6A.91.91,0,0,1,155.06,19.05Z",
    transform: "translate(-3.44 -2)",
    fill: "#fff"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M159.56,19a2.88,2.88,0,0,1-2.06-.82,3.3,3.3,0,0,1-1-2.4,3.9,3.9,0,0,1,.79-2.55A3.21,3.21,0,0,1,160,11.88a2.42,2.42,0,0,1,2.06,1,3.77,3.77,0,0,1,.69,2.31,4.13,4.13,0,0,1-.8,2.56A2.89,2.89,0,0,1,159.56,19Zm.39-5.39a1.4,1.4,0,0,0-1.25.73,2.63,2.63,0,0,0-.39,1.44,1.55,1.55,0,0,0,.44,1.19,1.13,1.13,0,0,0,.81.33,1.42,1.42,0,0,0,1-.38,1.72,1.72,0,0,0,.5-1.21C161.1,14.29,160.74,13.59,160,13.58Z",
    transform: "translate(-3.44 -2)",
    fill: "#fff"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M172.14,12.89c-.45,1.69-.9,3.22-1.36,4.6a4.4,4.4,0,0,1-.64,1.2.92.92,0,0,1-.82.42c-.55,0-1-.53-1.29-1.57a21.71,21.71,0,0,1-.41-2.22c-.09.19-.15.32-.17.38-.22.54-.55,1.37-1,2.49a1.06,1.06,0,0,1-.29.44.92.92,0,0,1-.81.45c-.21,0-.42-.17-.64-.54a5,5,0,0,1-.58-1.45c-.13-.54-.34-1.7-.62-3.5a6.36,6.36,0,0,1-.09-.91.74.74,0,0,1,.27-.59.93.93,0,0,1,.64-.24.8.8,0,0,1,.86.69,5.71,5.71,0,0,1,.14.9c.06.5.09.8.1.9.06.33.14.88.26,1.65.32-.88.69-2,1.1-3.27a1,1,0,0,1,1-.84c.48,0,.79.31.94.93.11.44.22,1,.34,1.72.18,1,.29,1.63.33,1.82,0-.13.38-1.44,1-3.93a.74.74,0,0,1,.81-.56,1,1,0,0,1,.65.24.76.76,0,0,1,.29.6A1.3,1.3,0,0,1,172.14,12.89Z",
    transform: "translate(-3.44 -2)",
    fill: "#fff"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M177.89,14.4l-1.07.75a5.29,5.29,0,0,0-1,.84,1,1,0,0,1-.69.34.91.91,0,0,1-.65-.27.85.85,0,0,1-.28-.62c0-.34.28-.73.84-1.16l1.54-1.09c.56-.42.83-.8.83-1.15a1.47,1.47,0,0,0-.61-1.12,1.88,1.88,0,0,0-1.27-.53,2,2,0,0,0-1,.4,2,2,0,0,1-.86.39.83.83,0,0,1-.64-.28.86.86,0,0,1-.26-.62c0-.43.37-.83,1.13-1.19a4,4,0,0,1,1.59-.46,3.68,3.68,0,0,1,2.54,1A3.13,3.13,0,0,1,179.22,12,3,3,0,0,1,177.89,14.4Zm-3.11,4.65a1,1,0,0,1-.67-.23.79.79,0,0,1-.33-.64,1.45,1.45,0,0,1,.26-.82,1,1,0,0,1,.83-.46.8.8,0,0,1,.69.33,1.11,1.11,0,0,1,.19.65,1.37,1.37,0,0,1-.21.73A.83.83,0,0,1,174.78,19.05Z",
    transform: "translate(-3.44 -2)",
    fill: "#fff"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M212.62,59c-.27.56-.82,1.76-1.64,3.61-.67,1.55-1.25,2.77-1.73,3.65-.83,1.53-1.27,2.33-1.33,2.42a1.3,1.3,0,0,1-1.08.7,1.15,1.15,0,0,1-.77-.29,1,1,0,0,1-.37-.79A16,16,0,0,1,207.36,65c-.41-.59-1-1.48-1.76-2.68q-.85-1.32-2.52-4a1.13,1.13,0,0,1-.16-.56,1,1,0,0,1,.36-.78,1.12,1.12,0,0,1,.78-.3,1.24,1.24,0,0,1,1,.54l.59.95c0,.07.5.84,1.37,2.33a20.12,20.12,0,0,0,1.47,2.25q.6-1.22,1.74-3.69l.72-1.66a1,1,0,0,1,1-.72,1.15,1.15,0,0,1,.77.29,1,1,0,0,1,.37.78A4.25,4.25,0,0,1,212.62,59Z",
    transform: "translate(-3.44 -2)",
    fill: "#fff"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M218.19,69.15a5.06,5.06,0,0,1-3.11-.91,3.31,3.31,0,0,1-1.34-2.83A5.43,5.43,0,0,1,214.8,62,3.78,3.78,0,0,1,218,60.46a5.18,5.18,0,0,1,2.3.45,1.92,1.92,0,0,1,1.2,1.83,1.9,1.9,0,0,1-1,1.55,12.71,12.71,0,0,1-1.8.91L216,66.38A2.34,2.34,0,0,0,217,67a3.85,3.85,0,0,0,3-.23,2.31,2.31,0,0,1,1.06-.39.73.73,0,0,1,.83.81c0,.6-.44,1.1-1.33,1.48A5.89,5.89,0,0,1,218.19,69.15ZM218,62.39a1.77,1.77,0,0,0-1.26.49,3.59,3.59,0,0,0-.85,1.48l1.79-.77a12.56,12.56,0,0,0,1.72-.9A2.85,2.85,0,0,0,218,62.39Z",
    transform: "translate(-3.44 -2)",
    fill: "#fff"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M228.89,63a.84.84,0,0,1-.94-.66,4.77,4.77,0,0,0-.66,0c-1.28,0-1.92.17-1.92.52s.39.49,1.16.84a13.89,13.89,0,0,1,2.13,1.13,2.35,2.35,0,0,1,1.16,1.89,2.25,2.25,0,0,1-1.28,2.07,5.1,5.1,0,0,1-2.52.57,5.49,5.49,0,0,1-1.94-.33c-.79-.3-1.19-.73-1.19-1.31s.32-.8,1-.8a3.83,3.83,0,0,1,1.06.23,3.43,3.43,0,0,0,1.06.23c1.08,0,1.62-.21,1.63-.65,0-.27-.38-.57-1.13-.9a16.38,16.38,0,0,1-2.1-1,2.33,2.33,0,0,1-1.12-1.92,2.16,2.16,0,0,1,1.7-2.16,10.68,10.68,0,0,1,3-.32,2.72,2.72,0,0,1,1.18.2,1.06,1.06,0,0,1,.52,1C229.66,62.48,229.41,63,228.89,63Z",
    transform: "translate(-3.44 -2)",
    fill: "#fff"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M232.31,69.31a1.18,1.18,0,0,1-.89-.51,1.46,1.46,0,0,1-.37-.88.87.87,0,0,1,.32-.69,1.1,1.1,0,0,1,.74-.28,1.15,1.15,0,0,1,.89.51,1.41,1.41,0,0,1,.37.87.9.9,0,0,1-.32.69A1.08,1.08,0,0,1,232.31,69.31Zm0-2.89a1.06,1.06,0,0,1-.74-.28,1,1,0,0,1-.29-.7c0-.21,0-.52,0-.93s0-.72,0-.93c0-.73,0-1.83,0-3.29s0-2.56,0-3.3a.92.92,0,0,1,.3-.7,1,1,0,0,1,.73-.28,1,1,0,0,1,.73.28.91.91,0,0,1,.29.7v8.45a.91.91,0,0,1-.29.7A1,1,0,0,1,232.34,66.42Z",
    transform: "translate(-3.44 -2)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebFigureTeaser);
export default __webpack_public_path__ + "static/media/web-figure-teaser.1777cb486d90b9658ea253f76b8e3d75.svg";
export { ForwardRef as ReactComponent };